import React, { useState, useEffect, useRef } from "react";
import ReactMarkdown from "react-markdown";
import * as speechsdk from 'microsoft-cognitiveservices-speech-sdk';
import TabList from './components/TabList';
import { FaFileAlt, FaImage, FaSlidersH, FaVolumeUp, FaProjectDiagram, FaChartBar, FaSitemap, FaCube, FaSpinner, FaSyncAlt, FaSignOutAlt, FaCog, FaPlay, FaMarkdown, FaEnvelopeOpenText, FaCloudDownloadAlt, FaPrint } from 'react-icons/fa';
import './GenAIApp.css';
import { collection, doc, where, addDoc, getDocs, getDoc, query, orderBy, startAfter, limit, updateDoc } from 'firebase/firestore';
import {
    onAuthStateChanged,
    signOut,
} from 'firebase/auth';
import { auth, db } from './Firebase';
import VoiceSelect from './VoiceSelect';
import Homework from "./Homework";
import MarkdownIt from 'markdown-it';
import MdEditor from 'react-markdown-editor-lite';
// import style manually
import 'react-markdown-editor-lite/lib/index.css';
import { DrawIoEmbed } from 'react-drawio';
import PromptEditor from './PromptEditor';
import { unified } from 'unified';
import remarkParse from 'remark-parse';
import remarkDocx from 'remark-docx';
import { saveAs } from 'file-saver';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import { OS } from "microsoft-cognitiveservices-speech-sdk/distrib/lib/src/common.speech/SpeechServiceConfig";

const speechKey = process.env.REACT_APP_AZURE_SPEECH_API_KEY;
const serviceRegion = 'eastus';
const isiPhone = /iPhone/i.test(navigator.userAgent);
console.log(isiPhone);
let searchQuery = '';
let systemLevelPrompt = '';
let userLevelPrompt = '';
let invocationType = '';
let searchModel = 'All';
let userID = '';
let dataLimit = 11;
let fetchMoreDataLimit = 21;
let generatedDocID = '';
let ttsGeneratedDocID = '';
let imageGenerationPromptInput = '';
let attachmentInformation = '';
const priceId = 'price_1RIIcABav3Pxs3NbuC2sUotz';
let voiceInstructions = 'Voice Affect: Professional news reader quality pronunciation.\n\nTone: Confident and cheerful.\n\nPacing: Steady and measured.\n\nEmotion: Happy tone.\n\nPronunciation: go easy on letter s in words so that you can avoid hissing sound.\n\nPauses: Use thoughtful pauses.';
let autoPromptSeparator = '### all the text from below is strictly for reference and prompt purpose to answer the question asked above this line. ######### '
let questionTrimLength = 200;
let chunk_size = 4000;
let adminUser = false;
let genai_image_label = 'GenAI Image';
let genai_youtube_label = 'YouTube';
let genai_audio_label = 'Audio';
let genai_autoprompt_label = 'AutoPrompt';
let ttsVoiceName = 'en-US-EvelynNeural';
let googleTTSVoiceName = 'en-US-Chirp-HD-F';
let modelAnthropic = 'claude';
let modelGemini = 'gemini';
let modelGeminiImage = 'gemini-image';
let modelGeminiSearch = 'gemini-search';
let modelGeminiThink = 'gemini-think';
let modelGeminiThinkFast = 'gemini-flash';
let modelGpt = 'gpt';
let modelGptSearch = 'gpt-search';
let modeloMini = 'o-mini-think';
let modelo = 'o-think';
let modelLlama = 'llama';
let modelMistral = 'mistral';
let modelGptImage = 'gpt-image';
let modelPerplexity = 'perplexity';
let modelPerplexityThink = 'perplexity-think';
let modelDeepSeek = 'deepseek-chat';
let modelDeepSeekThink = 'deepseek-think';
let modelDeepSeekChat = 'deepseek-chat';
let modelCodestralApi = 'mistral-codestral-api';
let modelNova = 'nova';
let modelGroq = 'groq';
let modelCerebras = 'llama-c';
let modelClaudeThinking = 'claude-think';
let modelChatGPT = 'chatgpt';
let autoPromptNumber = 0;
let textPlaceHolderText = 'Enter your question or request here... or Attach document (pdf,csv,txt,docx,xlsx,pptx) or image (jpg,png,webp,gif) to extract text \nAdd/Remove GenAI Models (Optional).\nSearch for predefined prompts if needed (optional) \nClick on the "GeneAI" button to get the response.';
let imagePlaceHolderText = 'Enter your image generation prompt here... ... or Attach document (pdf,csv,txt,docx,xlsx,pptx). \nExample: "Generate an image of a cat wearing a hat".';
let audioPlaceHolderText = 'Enter your text to genreate speech or audio.....  or Attach document (pdf,csv,txt,docx,xlsx,pptx) or image (jpg,png,webp,gif) to extract text \nAdjust Sppech Rate or Silence between sentences (Optional).\nSelect voice (optional) and Click on one of the Gen AI Audio generation models';
let diagramsPlaceHolderText = 'Enter your text to generate or Attach document (pdf,csv,txt,docx,xlsx,pptx) to generate SVG image of diagrams, geometric shapes, graphs with x,y axes.\nAdd/Remove GenAI Models.\nClick on the "GenAI" button to see the images below.';
let chartsPlaceHolderText = 'Enter your text or Attach document (csv, xlsx) to generate Charts and Business Intelligence Dashboards of information... \nAdd/Remove GenAI Models.\nClick on the "GenAI" button to get the response.';
let workflowPlaceHolderText = 'Enter your text or Attach whiteboard drawing picture or rough sketch or image (jpg,png,gif,webp) to generate draw-io workflow or architecture diagrams... \nAdd/Remove GenAI Models.\nClick on the "GenAI" button to get the response.';
let threeDModelPlaceHolderText = 'Enter your text to generate Openscad code for 3D model... \nAdd/Remove GenAI Models.\nClick on the "GenAI" button to get the response.';
let agentsPlaceHolderText = 'Enter your text or Attach document (pdf,csv,txt,docx,xlsx,pptx)\nClick on respective agent button.';

const GenAIApp = ({ sourceImageInformation }) => {
    // **State Variables**
    const [placeholderText, setPlaceholderText] = useState(textPlaceHolderText);
    const [isAppsMenuOpen, setIsAppsMenuOpen] = useState(false);
    const [isGeneratingImages, setIsGeneratingImages] = useState(false);
    const [isGeneratingYouTubeMusic, setIsGeneratingYouTubeMusic] = useState(false);
    const [generateGeminiImage, setGenerateGeminiImage] = useState(true);
    const [generateGptImage, setGenerateGptImage] = useState(true);
    const [showDownloadTextButton, setShowDownloadTextButton] = useState(false);
    const [genaiData, setGenaiData] = useState([]);
    const [isFileAttached, setIsFileAttached] = useState(false);
    const [isDownloading, setIsDownloading] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const [lastVisible, setLastVisible] = useState(null); // State for the last visible document
    const [isLiveAudioPlayingPrompt, setIsLiveAudioPlayingPrompt] = useState(false);
    const [isGeneratingYouTubeAudioTitlePrompt, setIsGeneratingYouTubeAudioTitlePrompt] = useState(false);
    const [isGeneratingDocx, setIsGeneratingDocx] = useState(false); // Add state for DOCX generation
    // Authentication state
    // Add state for editing config
    const [editingConfigId, setEditingConfigId] = useState(null);
    const [editedConfigContent, setEditedConfigContent] = useState('');
    const [user, setUser] = useState(null);
    const [email, setEmail] = useState('');
    const [uid, setUid] = useState(null);
    const [isUploading, setIsUploading] = useState(false);
    const [promptInput, setPromptInput] = useState('');
    const [isRefreshing, setIsRefreshing] = useState(false);
    const [isGenerating, setIsGenerating] = useState(false);
    const [isGeneratingGemini, setIsGeneratingGemini] = useState(false);
    const [isGeneratingAnthropic, setIsGeneratingAnthropic] = useState(false);
    const [isGeneratingoMini, setisGeneratingoMini] = useState(false);
    const [isGeneratingImage_Dall_e_3, setIsGeneratingImage_Dall_e_3] = useState(false);
    const [isChatGPT, setIsChatGPT] = useState(false);
    const [isGeneratingChatGPT, setIsGeneratingChatGPT] = useState(false);
    const [isGpt, setisGpt] = useState(false);
    const [isAnthropic, setIsAnthropic] = useState(true);
    const [isClaudeThinking, setIsClaudeThinking] = useState(false);
    const [isGemini, setIsGemini] = useState(true);
    const [isoMini, setIsoMini] = useState(true);
    const [isLlama, setIsLlama] = useState(false);
    const [isMistral, setIsMistral] = useState(false);
    const [isGptSearch, setIsGptSearch] = useState(false);
    const [isGeminiSearch, setIsGeminiSearch] = useState(true);
    const [isGeminiThink, setIsGeminiThink] = useState(true);
    const [isPerplexityThink, setIsPerplexityThink] = useState(false);
    const [isPerplexity, setIsPerplexity] = useState(false);
    const [isCodestral, setIsCodestral] = useState(false);
    const [showSettings, setShowSettings] = useState(false);
    const [isGeneratingGeminiSearch, setIsGeneratingGeminiSearch] = useState(false);
    const [isGeneratingGeminiFlash, setIsGeneratingGeminiFlash] = useState(false);
    const [isGeneratingPerplexityThink, setIsGeneratingPerplexityThink] = useState(false);
    const [isGeneratingTTS, setIsGeneratingTTS] = useState(false);
    const [iso1, setIso1] = useState(false); // New state for o1
    const [isGeneratingo, setisGeneratingo] = useState(false);
    const [isGeneratingLlama, setIsGeneratingLlama] = useState(false);
    const [isGeneratingGptSearch, setIsGeneratingGptSearch] = useState(false);
    const [isGeneratingPerplexity, setIsGeneratingPerplexity] = useState(false);
    const [isGeneratingCodeStral, setIsGeneratingCodeStral] = useState(false);
    const [isGeneratingMistral, setIsGeneratingMistral] = useState(false);
    const [voiceName, setVoiceName] = useState('en-US-EvelynMultilingualNeural');
    const [genaiPrompts, setGenaiPrompts] = useState([]);
    const [showEditPopup, setShowEditPopup] = useState(false);
    const [selectedPrompt, setSelectedPrompt] = useState(null);
    const [selectedPromptFullText, setSelectedPromptFullText] = useState(null);
    const [showMainApp, setShowMainApp] = useState(false);
    const [GenAIParameter, setGenAIParameter] = useState(false);
    const [temperature, setTemperature] = useState(0.7);
    const temperatureRef = useRef(temperature);
    const [top_p, setTop_p] = useState(0.8);
    const top_pRef = useRef(top_p);
    const [showTemp, setShowTemp] = useState(false);
    const [showTop_p, setShowTop_p] = useState(false);
    const [showGptSearch, setShowGptSearch] = useState(true);
    const [showMistral, setShowMistral] = useState(false);
    const [showLlama, setShowLlama] = useState(false);
    const [showChatGPT, setShowChatGPT] = useState(true);
    const [showGeminiSearch, setShowGeminiSearch] = useState(false);
    const [showGeminiThink, setShowGeminiThink] = useState(true);
    const [showPerplexityThink, setShowPerplexityThink] = useState(true);
    const [showPerplexity, setShowPerplexity] = useState(true);
    const [showCodeStral, setShowCodeStral] = useState(false);
    const [showGemini, setShowGemini] = useState(false);
    const [showClaudeThinking, setShowClaudeThinking] = useState(false);
    const [showAnthropic, setShowAnthropic] = useState(false);
    const [showGpt, setshowGpt] = useState(false);
    const [showo, setshowo] = useState(false);
    const [showImageDallE3, setShowImageDallE3] = useState(false);
    const [showTTS, setShowTTS] = useState(false);
    const [showoMini, setshowoMini] = useState(false);
    const [autoPrompt, setAutoPrompt] = useState(false);
    const [showYouTubeButton, setShowYouTubeButton] = useState(false);
    const mdParser = new MarkdownIt(/* Markdown-it options */);
    const [showConfigPopup, setShowConfigPopup] = useState(false);
    const [configData, setConfigData] = useState([]);
    const [showPromptEditor, setShowPromptEditor] = useState(false);
    // Add new state variables for prompt search
    const [promptSearchQuery, setPromptSearchQuery] = useState('');
    const [ShowSearchQuery, setShowSearchQuery] = useState(false);

    // Add new state variables for Claude-Haiku
    const [isDeepSeekChat, setIsDeepSeekChat] = useState(false);
    const [isGeneratingDeepSeekChat, setIsGeneratingDeepSeekChat] = useState(false);

    // Add showDeepSeekChat state variable
    const [showDeepSeekChat, setShowDeepSeekChat] = useState(false); // Set to true or false as needed

    // Add new state variables for DeepSeekThink
    const [isDeepSeekThink, setIsDeepSeekThink] = useState(false);
    const [isGeneratingDeepSeekThink, setIsGeneratingDeepSeekThink] = useState(false);
    const [showDeepSeekThink, setShowDeepSeekThink] = useState(false);
    // Add new state variables near other model state variables
    const [isGroq, setIsGroq] = useState(false);
    const [isGeneratingGroq, setIsGeneratingGroq] = useState(false);
    const [showGroq, setShowGroq] = useState(false);
    const [labelGroq, setLabelGroq] = useState('Llama');

    // Add new state variables for nova after other model state variables
    const [isNova, setIsNova] = useState(false);
    const [isGeneratingNova, setIsGeneratingNova] = useState(false);
    const [showNova, setShowNova] = useState(false);
    // Add these state variables near other state declarations
    const [labelGpt, setLabelGpt] = useState('ChatGPT');
    const [labelAnthropic, setLabelAnthropic] = useState('Claude');
    const [labelGemini, setLabelGemini] = useState('Gemini');
    const [labeloMini, setLabeloMini] = useState('o3-mini');
    const [labelMistral, setLabelMistral] = useState('Mistral');
    const [labelLlama, setLabelLlama] = useState('Llama(405B)');
    const [labelGptSearch, setLabelGptSearch] = useState('GPT Search');
    const [labelGeminiSearch, setLabelGeminiSearch] = useState('Gemini Search');
    const [labelGeminiThink, setlabelGeminiThink] = useState('Gemini Think');
    const [labelChatGPT, setLabelChatGPT] = useState('ChatGPT');
    const [labelo, setLabelo] = useState('o1');
    const [labelPerplexityThink, setLabelPerplexityThink] = useState('Perplexity Think Search');
    const [labelPerplexity, setLabelPerplexity] = useState('Perplexity Search');
    const [labelCodestral, setLabelCodestral] = useState('CodeStral');
    const [labelDeepSeekChat, setLabelDeepSeekChat] = useState('DeepSeek');
    const [labelDeepSeekThink, setLabelDeepSeekThink] = useState('DeepSeek Think');
    const [labelNova, setLabelNova] = useState('Nova');
    // Add these state variables near other state declarations
    const [isLiveAudioPlaying, setIsLiveAudioPlaying] = useState({});
    const [isGeneratingDownloadableAudio, setIsGeneratingDownloadableAudio] = useState({});
    // Add new state variable for YouTube audio title button
    const [showhomeWorkApp, setShowhomeWorkApp] = useState(false);
    const [currentDocId, setCurrentDocId] = useState(null);
    const currentDocIdRef = useRef(currentDocId);
    const [showPromptsDropDown, setShowPromptsDropDown] = useState(false);
    const [showEditPromptButton, setShowEditPromptButton] = useState(false);
    const [showBackToAppButton, setShowBackToAppButton] = useState(false);
    const [speechRate, setSpeechRate] = useState('0%');
    const [speechSilence, setSpeechSilence] = useState(200);
    const [youtubeSpeecRate, setYoutubeSpeechRate] = useState('0%');
    const [youtubeSpeechSilence, setYoutubeSpeechSilence] = useState(200);
    const [storyTellingSpeechRate, setStoryTellingSpeechRate] = useState('-25%');
    const [storyTellingSpeechSilence, setStoryTellingSpeechSilence] = useState(1200);

    // Add refs for speech variables
    const speechRateRef = useRef(speechRate);
    const speechSilenceRef = useRef(speechSilence);
    const youtubeSpeecRateRef = useRef(youtubeSpeecRate);
    const youtubeSpeechSilenceRef = useRef(youtubeSpeechSilence);
    const storyTellingSpeechRateRef = useRef(storyTellingSpeechRate);
    const storyTellingSpeechSilenceRef = useRef(storyTellingSpeechSilence);
    const promptInputRef = useRef(promptInput);

    // Update refs when state changes
    useEffect(() => {
        youtubeSpeecRateRef.current = youtubeSpeecRate;
        youtubeSpeechSilenceRef.current = youtubeSpeechSilence;
        storyTellingSpeechRateRef.current = storyTellingSpeechRate;
        storyTellingSpeechSilenceRef.current = storyTellingSpeechSilence;
        speechRateRef.current = speechRate;
        speechSilenceRef.current = speechSilence;
        promptInputRef.current = promptInput;
        currentDocIdRef.current = currentDocId;
    }, [youtubeSpeecRate, youtubeSpeechSilence, storyTellingSpeechRate, storyTellingSpeechSilence, speechRate, speechSilence, promptInput, currentDocId]);

    // Add new show state variables
    const [showPrint, setShowPrint] = useState(false);

    // Add new state variables after other model state variables
    const [isCerebras, setIsCerebras] = useState(false);
    const [isGeneratingCerebras, setIsGeneratingCerebras] = useState(false);
    const [showCerebras, setShowCerebras] = useState(false);
    const [labelCerebras, setLabelCerebras] = useState('Llama-C');

    // Add new model "DeepSeek" state variables
    const [isDeepSeek, setIsDeepSeek] = useState(false);
    const [isGeneratingDeepSeek, setIsGeneratingDeepSeek] = useState(false);
    const [showDeepSeek, setShowDeepSeek] = useState(false);
    const [labelDeepSeek, setLabelDeepSeek] = useState('DS');

    const [labelClaudeThinking, setLabelClaudeThinking] = useState('Claude Think');
    const [isGeneratingClaudeThinking, setIsGeneratingClaudeThinking] = useState(false);


    // Add new state variables with other model states
    const [isGeminiThinkFast, setIsGeminiThinkFast] = useState(false);
    const [isGeneratingGeminiFlashFast, setIsGeneratingGeminiFlashFast] = useState(false);
    const [showGeminiThinkFast, setShowGeminiThinkFast] = useState(false);
    const [labelGeminiThinkFast, setlabelGeminiThinkFast] = useState('Gemini Flash');
    const [outputType, setOutputType] = useState('text');

    // Define predefined prompts for filtering
    const predefinedPrompts = [
        { tag: 'explain' },
        { tag: 'answer' },
        { tag: 'svg-geometry' },
        { tag: 'svg-dashboards' },
        { tag: 'draw-io' },
        { tag: '3D_Model' },
        { tag: 'practice_questions' },
        { tag: 'quiz' },
        { tag: 'mom' },
        { tag: 'Feedback' },
        { tag: 'Summary' },
        { tag: 'lyrics' },
        { tag: 'reviews' },
        { tag: 'Tech_News' },
        { tag: 'USA_News' },
        { tag: 'MSWord' },
        { tag: 'Search-GenAI' }
    ];


    useEffect(() => {
        temperatureRef.current = temperature;
        top_pRef.current = top_p;
    }, [temperature, top_p]);

    const embedPrompt = async (docId) => {
        try {
            console.log('Embedding prompt:', docId);
            const response = await fetch(`${process.env.REACT_APP_GENAI_API_URL}embed-prompt`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ doc_id: docId, uid: uid })
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.error || 'Failed to embed prompt.');
            }
            const data = await response.json();
            console.log('Embed Prompt Response:', data);
        } catch (error) {
            console.error('Error embedding prompt:', error);
            alert(`Error: ${error.message}`);
        }
    };
    // Helper function to get URL parameters
    const getUrlParameter = (name) => {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        return urlParams.get(name);
    };

    const telugu = getUrlParameter('telugu');
    const hindi = getUrlParameter('hindi');

    // Helper function to truncate questions based on limit
    const getQuestionSubstring = (question) => {
        const marker = '###';
        // if question is undefined or null, return an empty string
        if (!question) {
            return '';
        }
        // if length of the question is less than the limit, return the question
        if (question.length <= questionTrimLength) {
            return question;
        }
        const markerIndex = question.indexOf(marker);
        if (markerIndex !== -1) {
            return question.substring(0, Math.min(markerIndex, questionTrimLength));
        }
        else {
            return question.substring(0, questionTrimLength);
        }
    };

    // Listen for authentication state changes
    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
            setUser(currentUser);
            if (currentUser) {
                userID = currentUser.uid;
                console.log('User is signed in:', currentUser.uid);
                const urlParams = new URLSearchParams(window.location.search);
                const genaiParam = urlParams.get('genai');
                if (genaiParam) {
                    setGenAIParameter(true);
                }
                if (process.env.REACT_APP_MAIN_APP === 'GenAI') {
                    setGenAIParameter(true);
                }
                setUid(currentUser.uid);
                setEmail(currentUser.email);
                console.log('User is signed in:', currentUser.uid);
                console.log('isGeneratingGeminiSearch:', isGeneratingGeminiSearch);

                // Fetch data for the authenticated user
                fetchData(currentUser.uid);
                fetchPrompts(currentUser.uid);
                await checkAdminUsers();
                await fetchGenAIParameters(currentUser.uid);
                await fetchTexts();
                // Set visibility of back button based on admin status
                setShowBackToAppButton(adminUser);
            }
            else {
                console.log('No user is signed in');
            }
        });
        return () => unsubscribe();
    }, []);

    const checkAdminUsers = async () => {
        console.log('Fetching genai parameters...');
        const configurationCollection = collection(db, 'public');
        const q = query(configurationCollection, where('setup', '==', 'genaiAdmin'));
        const adminSnapshot = await getDocs(q);
        const adminEmails = [];
        adminSnapshot.docs.forEach(doc => {
            const data = doc.data();
            if (data.emailAddresses && Array.isArray(data.emailAddresses)) {
                adminEmails.push(...data.emailAddresses);
            }
        });
        if (adminEmails.includes(auth.currentUser.email)) {
            console.log('Admin user:', auth.currentUser.email);
            adminUser = true;
        } else {
            console.log('Not an admin user:', auth.currentUser.email);
            adminUser = false;
        }
    }
    const fetchGenAIParameters = async (firebaseUserID) => {
        try {
            if (!firebaseUserID) {
                console.error('No user ID provided');
                return;
            }
            let q = '';
            const configurationCollection = collection(db, 'public');
            q = query(configurationCollection, where('setup', '==', 'genaiAdmin'));

            const configurationSnapshot = await getDocs(q);
            configurationSnapshot.forEach(doc => {
                const data = doc.data();
                console.log('Fully Array Data:', data);
                console.log('Data:', data.temperature, data.top_p);
                console.log('showGemini:', data.showGemini);
                console.log('showGpt:', data.showGpt);
                console.log('showGptSearch:', data.showGptSearch);
                if (data.temperature !== undefined) {
                    setTemperature(data.temperature);
                }
                if (data.top_p !== undefined) {
                    setTop_p(data.top_p);
                }
                if (data.autoPrompt !== undefined) {
                    setAutoPrompt(data.autoPrompt);
                }
                if (data.dataLimit !== undefined) {
                    dataLimit = data.dataLimit;
                }
                if (data.fetchMoreDataLimit !== undefined) {
                    fetchMoreDataLimit = data.fetchMoreDataLimit;
                }
                if (data.isGroq !== undefined) {
                    setIsGroq(data.isGroq);
                }
                if (data.isAnthropic !== undefined) {
                    setIsAnthropic(data.isAnthropic);
                }
                if (data.isGemini !== undefined) {
                    setIsGemini(data.isGemini);
                }
                if (data.isGpt !== undefined) {
                    setisGpt(data.isGpt);
                }
                if (data.isoMini !== undefined) {
                    setIsoMini(data.isoMini);
                }
                if (data.iso1 !== undefined) {
                    setIso1(data.iso1);
                }
                if (data.showImageDallE3 !== undefined) {
                    setShowImageDallE3(data.showImageDallE3);
                }
                if (data.showTTS !== undefined) {
                    setShowTTS(data.showTTS);
                }
                if (data.isLlama !== undefined) {
                    setIsLlama(data.isLlama);
                }
                if (data.isMistral !== undefined) {
                    setIsMistral(data.isMistral);
                }
                if (data.isGptSearch !== undefined) {
                    setIsGptSearch(data.isGptSearch);
                }
                if (data.isChatGPT !== undefined) {
                    setIsChatGPT(data.isChatGPT);
                }
                if (data.isGeminiSearch !== undefined) {
                    setIsGeminiSearch(data.isGeminiSearch);
                }
                if (data.isGeminiThink !== undefined) {
                    setIsGeminiThink(data.isGeminiThink);
                }
                if (data.isPerplexityThink !== undefined) {
                    setIsPerplexityThink(data.isPerplexityThink);
                }
                if (data.isPerplexity !== undefined) {
                    setIsPerplexity(data.isPerplexity);
                }
                if (data.isCodestral !== undefined) {
                    setIsCodestral(data.isCodestral);
                }
                if (data.isDeepSeekChat !== undefined) {
                    setIsDeepSeekChat(data.isDeepSeekChat);
                }
                if (data.isDeepSeekThink !== undefined) {
                    setIsDeepSeekThink(data.isDeepSeekThink);
                }
                if (data.showAnthropic !== undefined) {
                    setShowAnthropic(data.showAnthropic);
                }
                if (data.showGemini !== undefined) {
                    setShowGemini(data.showGemini);
                }
                if (data.showGpt !== undefined) {
                    setshowGpt(data.showGpt);
                }
                if (data.showGptSearch !== undefined) {
                    // setShowGptSearch(data.showGptSearch);
                }
                if (data.showMistral !== undefined) {
                    setShowMistral(data.showMistral);
                }
                if (data.showPerplexityThink !== undefined) {
                    setShowPerplexityThink(data.showPerplexityThink);
                }
                if (data.showPerplexity !== undefined) {
                    setShowPerplexity(data.showPerplexity);
                }
                if (data.showChatGPT !== undefined) {
                    setShowChatGPT(data.showChatGPT);
                }
                if (data.showGeminiSearch !== undefined) {
                    console.log('Setting showGeminiSearch:', data.showGeminiSearch);
                    setShowGeminiSearch(data.showGeminiSearch);
                }
                if (data.showGeminiThink !== undefined) {
                    setShowGeminiThink(data.showGeminiThink);
                }
                if (data.showCodeStral !== undefined) {
                    setShowCodeStral(data.showCodeStral);
                }
                if (data.showLlama !== undefined) {
                    setShowLlama(data.showLlama);
                }
                if (data.showo !== undefined) {
                    setshowo(data.showo);
                }
                if (data.showoMini !== undefined) {
                    setshowoMini(data.showoMini);
                }
                if (data.showDeepSeekChat !== undefined) {
                    setShowDeepSeekChat(data.showDeepSeekChat);
                }
                if (data.showDeepSeekThink !== undefined) {
                    setShowDeepSeekThink(data.showDeepSeekThink);
                }
                if (data.showGroq !== undefined) {
                    setShowGroq(data.showGroq);
                }
                if (data.showNova !== undefined) {
                    setShowNova(data.showNova);
                }
                if (data.labelGroq !== undefined) {
                    setLabelGroq(data.labelGroq);
                }
                if (data.labelGpt !== undefined) {
                    setLabelGpt(data.labelGpt);
                }
                if (data.labelAnthropic !== undefined) {
                    setLabelAnthropic(data.labelAnthropic);
                }
                if (data.labelGemini !== undefined) {
                    setLabelGemini(data.labelGemini);
                }
                if (data.labeloMini !== undefined) {
                    setLabeloMini(data.labeloMini);
                }
                if (data.labelMistral !== undefined) {
                    setLabelMistral(data.labelMistral);
                }
                if (data.labelLlama !== undefined) {
                    setLabelLlama(data.labelLlama);
                }
                if (data.labelGptSearch !== undefined) {
                    setLabelGptSearch(data.labelGptSearch);
                }
                if (data.labelGeminiSearch !== undefined) {
                    setLabelGeminiSearch(data.labelGeminiSearch);
                }
                if (data.labelGeminiThink !== undefined) {
                    setlabelGeminiThink(data.labelGeminiThink);
                }
                if (data.labelChatGPT !== undefined) {
                    setLabelChatGPT(data.labelChatGPT);
                }
                if (data.labelo !== undefined) {
                    setLabelo(data.labelo);
                }
                if (data.labelPerplexityThink !== undefined) {
                    setLabelPerplexityThink(data.labelPerplexityThink);
                }
                if (data.labelPerplexity !== undefined) {
                    setLabelPerplexity(data.labelPerplexity);
                }
                if (data.labelCodestral !== undefined) {
                    setLabelCodestral(data.labelCodestral);
                }
                if (data.labelDeepSeekChat !== undefined) {
                    setLabelDeepSeekChat(data.labelDeepSeekChat);
                }
                if (data.labelDeepSeekThink !== undefined) {
                    setLabelDeepSeekThink(data.labelDeepSeekThink);
                }
                if (data.labelNova !== undefined) {
                    setLabelNova(data.labelNova);
                }
                if (data.showYouTubeButton !== undefined) {
                    setShowYouTubeButton(data.showYouTubeButton);
                }
                if (data.voiceName !== undefined) {
                    setVoiceName(data.voiceName);
                }
                if (data.chunk_size !== undefined) {
                    chunk_size = data.chunk_size;
                }
                if (data.showPromptsDropDown !== undefined) {
                    setShowPromptsDropDown(data.showPromptsDropDown);
                }
                if (data.showEditPromptButton !== undefined) {
                    setShowEditPromptButton(data.showEditPromptButton);
                }
                if (data.showBackToAppButton !== undefined) {
                    setShowBackToAppButton(data.showBackToAppButton);
                }
                if (data.showTemp !== undefined) {
                    setShowTemp(data.showTemp);
                }
                if (data.showTop_p !== undefined) {
                    setShowTop_p(data.showTop_p);
                }
                if (data.showPrint !== undefined) {
                    setShowPrint(data.showPrint);
                }
                if (data.isCerebras !== undefined) {
                    setIsCerebras(data.isCerebras);
                }
                if (data.showCerebras !== undefined) {
                    setShowCerebras(data.showCerebras);
                }
                if (data.labelCerebras !== undefined) {
                    setLabelCerebras(data.labelCerebras);
                }
                if (data.speechRate !== undefined) {
                    setSpeechRate(data.speechRate);
                }
                if (data.speechSilence !== undefined) {
                    setSpeechSilence(data.speechSilence);
                }
                if (data.youtubeSpeechRate !== undefined) {
                    setYoutubeSpeechRate(data.youtubeSpeechRate);
                }
                if (data.youtubeSpeechSilence !== undefined) {
                    setYoutubeSpeechSilence(data.youtubeSpeechSilence);
                }
                if (data.storyTellingSpeechRate !== undefined) {
                    setStoryTellingSpeechRate(data.storyTellingSpeechRate);
                }
                if (data.storyTellingSpeechSilence !== undefined) {
                    setStoryTellingSpeechSilence(data.storyTellingSpeechSilence);
                }
                if (data.showDownloadTextButton !== undefined) {
                    setShowDownloadTextButton(data.showDownloadTextButton);
                }
                if (data.generateGeminiImage !== undefined) {
                    setGenerateGeminiImage(data.generateGeminiImage);
                }
                if (data.generateGptImage !== undefined) {
                    setGenerateGptImage(data.generateGptImage);
                }
                if (data.isDeepSeek !== undefined) {
                    setIsDeepSeek(data.isDeepSeek);
                }
                if (data.showDeepSeek !== undefined) {
                    setShowDeepSeek(data.showDeepSeek);
                }
                if (data.labelDeepSeek !== undefined) {
                    setLabelDeepSeek(data.labelDeepSeek);
                }
                if (data.isGeminiThinkFast !== undefined) {
                    setIsGeminiThinkFast(data.isGeminiThinkFast);
                }
                if (data.showGeminiThinkFast !== undefined) {
                    setShowGeminiThinkFast(data.showGeminiThinkFast);
                }
                if (data.labelGeminiThinkFast !== undefined) {
                    setlabelGeminiThinkFast(data.labelGeminiThinkFast);
                }
                if (data.isClaudeThinking !== undefined) {
                    setIsClaudeThinking(data.isClaudeThinking);
                }
                if (data.showClaudeThinking !== undefined) {
                    setShowClaudeThinking(data.showClaudeThinking);
                }
                if (data.labelClaudeThinking !== undefined) {
                    setLabelClaudeThinking(data.labelClaudeThinking);
                }
            });
        } catch (error) {
            console.error("Error fetching genAI parameters: ", error);
            return [];
        }
    };
    // Fetch prompts from Firestore
    const fetchPrompts = async (userID) => {
        try {
            const genaiCollection = collection(db, 'genai', userID, 'prompts');
            const q = query(genaiCollection, limit(1000), orderBy('modifiedDateTime', 'desc'));
            const genaiSnapshot = await getDocs(q);
            const genaiList = genaiSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            setGenaiPrompts(genaiList);
        } catch (error) {
            console.error("Error fetching prompts: ", error);
        }
    };

    // Function to fetch data from Firestore
    const fetchData = async (userID) => {
        try {
            const genaiCollection = collection(db, 'genai', userID, 'MyGenAI');
            let q;
            q = query(genaiCollection, orderBy('createdDateTime', 'desc'), limit(dataLimit));
            if (hindi) {
                q = query(genaiCollection, orderBy('createdDateTime', 'desc'), where('language', '==', 'Hindi'), limit(dataLimit));
            }
            if (telugu) {
                q = query(genaiCollection, orderBy('createdDateTime', 'desc'), where('language', '==', 'Telugu'), limit(dataLimit));
            }
            const genaiSnapshot = await getDocs(q);
            const genaiList = genaiSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            const showFullQuestionState = {};
            genaiList.forEach(doc => {
                showFullQuestionState[doc.id] = false;
            });
            setShowFullQuestion(showFullQuestionState);
            setGenaiData(genaiList);
            setLastVisible(genaiSnapshot.docs[genaiSnapshot.docs.length - 1]); // Set last visible document
        } catch (error) {
            console.error("Error fetching data: ", error);
        }
    };

    // Handlers for input changes
    const handleLimitChange = (event) => {
        if (parseInt(event.target.value) > dataLimit) {
            dataLimit = parseInt(event.target.value);
            console.log('Data Limit:', dataLimit);
            bigQueryResults();
        }
    };

    const handleSearchChange = (event) => {
        searchQuery = event.target.value;
        bigQueryResults();
    };

    const handleInvocationChange = (event) => {
        invocationType = event.target.value;
        bigQueryResults();
    };

    const handleVectorSearchChange = (event) => {
        searchQuery = event.target.value;
        vectorSearchResults();
    };

    const [showFullQuestion, setShowFullQuestion] = useState({});

    // Helper function to split messages into chunks
    const splitMessage = (msg, chunkSize = 4000) => {
        const chunks = [];
        console.log('Before Splitting message:', msg);
        for (let i = 0; i < msg.length; i += chunkSize) {
            console.log('Part ', i, '  message:', msg.substring(i, i + chunkSize));
            chunks.push(msg.substring(i, i + chunkSize));
        }
        return chunks;
    };

    // Function to synthesize speech
    const synthesizeSpeech = async (articles, language) => {
        // Clean the text by removing URLs and special characters
        const cleanedArticles = articles
            .replace(/https?:\/\/[^\s]+/g, '') // Remove URLs
            .replace(/http?:\/\/[^\s]+/g, '') // Remove URLs
            .replace(/[#:\-*]/g, ' ')
            .replace(/[&]/g, ' and ')
            .replace(/[<>]/g, ' ')
            //       .replace(/["]/g, '&quot;')
            //       .replace(/[']/g, '&apos;')
            .trim(); // Remove leading/trailing spaces

        if (isiPhone) {
            window.scrollTo(0, 0);
            alert('Please go to top of the page to check status and listen to the audio');
            callTTSAPI(cleanedArticles, process.env.REACT_APP_TTS_SSML_API_URL);
            return;
        }
        try {
            try {
                console.log('Synthesizing speech...' + cleanedArticles);
                const speechConfig = speechsdk.SpeechConfig.fromSubscription(speechKey, serviceRegion);
                speechConfig.speechSynthesisVoiceName = voiceName;
                if (language === "Spanish") {
                    speechConfig.speechSynthesisVoiceName = "es-MX-DaliaNeural";
                }
                if (language === "Hindi") {
                    speechConfig.speechSynthesisVoiceName = "hi-IN-SwaraNeural";
                }
                if (language === "Telugu") {
                    speechConfig.speechSynthesisVoiceName = "te-IN-ShrutiNeural";
                }

                const audioConfig = speechsdk.AudioConfig.fromDefaultSpeakerOutput();
                const speechSynthesizer = new speechsdk.SpeechSynthesizer(speechConfig, audioConfig);

                const chunks = splitMessage(cleanedArticles);
                for (const chunk of chunks) {
                    await new Promise((resolve, reject) => {
                        speechSynthesizer.speakTextAsync(chunk, result => {
                            if (result.reason === speechsdk.ResultReason.SynthesizingAudioCompleted) {
                                console.log(`Speech synthesized to speaker for text: [${chunk}]`);
                                resolve();
                            } else if (result.reason === speechsdk.ResultReason.Canceled) {
                                const cancellationDetails = speechsdk.SpeechSynthesisCancellationDetails.fromResult(result);
                                if (cancellationDetails.reason === speechsdk.CancellationReason.Error) {
                                    console.error(`Error details: ${cancellationDetails.errorDetails}`);
                                    reject(new Error(cancellationDetails.errorDetails));
                                } else {
                                    reject(new Error('Speech synthesis canceled'));
                                }
                            }
                        }, error => {
                            console.error(`Error synthesizing speech: ${error}`);
                            reject(error);
                        });
                    });
                }
            } catch (error) {
                console.error(`Error synthesizing speech: ${error}`);
            } finally {
                setIsLiveAudioPlaying(false);
            }
        }
        catch (error) {
            console.error(`Error synthesizing speech: ${error}`);
        }
        finally {
            setIsLiveAudioPlaying(false);
        }
    };

    // Function to fetch more data for pagination
    const fetchMoreData = async () => {
        try {
            // get auth user
            const user = auth.currentUser;
            if (!user) {
                console.error("No user is signed in");
                return;
            }
            else {
                console.log('User is signed in:', user.uid);
                const genaiCollection = collection(db, 'genai', user.uid, 'MyGenAI');
                let nextQuery;
                nextQuery = query(genaiCollection, orderBy('createdDateTime', 'desc'), startAfter(lastVisible), limit(fetchMoreDataLimit));
                if (hindi) {
                    nextQuery = query(genaiCollection, orderBy('createdDateTime', 'desc'), where('language', '==', 'Hindi'), startAfter(lastVisible), limit(fetchMoreDataLimit));
                }
                if (telugu) {
                    nextQuery = query(genaiCollection, orderBy('createdDateTime', 'desc'), where('language', '==', 'Telugu'), startAfter(lastVisible), limit(fetchMoreDataLimit));
                }

                const genaiSnapshot = await getDocs(nextQuery);
                const genaiList = genaiSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
                setGenaiData(prevData => [...prevData, ...genaiList]);
                setLastVisible(genaiSnapshot.docs[genaiSnapshot.docs.length - 1]); // Update last visible document
            }
        } catch (error) {
            console.error("Error fetching more data: ", error);
        }
    };

    const generateAndDownloadYouTubeUploadInformation = async (message) => {
        const firestoreResponseData = message;
        console.log('First fetched data from Firestore:', firestoreResponseData);
        console.log('firestoreResponseData:', firestoreResponseData);
        if (firestoreResponseData === undefined || firestoreResponseData.length < 100) {
            alert('ERROR: Prompt response is not generated.');
            return;
        }

        setIsGemini(true);
        setIsGeneratingGemini(true);
        await callAPI(modelo, 'youtubeTitle', firestoreResponseData, 'YouTube_title');
        console.log('youtube Title Gen and Upload generatedDocID:', generatedDocID);
        const youtubeTitledocRef = doc(db, 'genai', user.uid, 'MyGenAI', generatedDocID);
        const youtubeTitledocSnap = await getDoc(youtubeTitledocRef);
        if (youtubeTitledocSnap.exists()) {
            console.log('Youtube title fetched data from Firestore:', youtubeTitledocSnap.data().answer);
            const plainText = (youtubeTitledocSnap.data().answer || '')
                .replace(/[#*~`>-]/g, '')
                .replace(/\r?\n/g, '\r\n');
            const blob = new Blob([plainText], { type: 'text/plain' });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = 'title.txt';
            link.click();
        }
        await callAPI(modelo, 'youtubeDescription', firestoreResponseData, 'YouTube_description');
        console.log('youtube Description Gen and Upload generatedDocID:', generatedDocID);
        const youtubeDescrdocRef = doc(db, 'genai', user.uid, 'MyGenAI', generatedDocID);
        const youtubeDescrdocSnap = await getDoc(youtubeDescrdocRef);
        if (youtubeDescrdocSnap.exists()) {
            console.log('Youtube title fetched data from Firestore:', youtubeDescrdocSnap.data().answer);
            const plainText = (youtubeDescrdocSnap.data().answer || '')
                .replace(/[#*~`>-]/g, '')
                .replace(/\r?\n/g, '\r\n');
            const blob = new Blob([plainText], { type: 'text/plain' });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = 'description.txt';
            link.click();
        }
        await callTTSAPI(firestoreResponseData, process.env.REACT_APP_TTS_SSML_API_URL);
        console.log('TTS generatedDocID:', ttsGeneratedDocID);
        const ttsdocRef = doc(db, 'genai', user.uid, 'MyGenAI', ttsGeneratedDocID);
        const ttsdocSnap = await getDoc(ttsdocRef);
        if (ttsdocSnap.exists()) {
            console.log('TTS fetched data from Firestore:', ttsdocSnap.data().answer);
            const audioURL = ttsdocSnap.data().answer;
            console.log('TTS audioURL:', audioURL);
            await handleDownload(audioURL, 'azure-tts');
        }

    };

    const generateYouTubeUploadInformation = async (message, invocation_source = 'youtube') => {
        const firestoreResponseData = message;
        console.log('First fetched data from Firestore:', firestoreResponseData);
        console.log('firestoreResponseData:', firestoreResponseData);
        if (firestoreResponseData === undefined || firestoreResponseData.length < 100) {
            alert('ERROR: Prompt response is not generated.');
            return;
        }
        // Execute YouTube Title/Description/Audio
        setIsGeneratingTTS(true);
        setIsGemini(true);
        setIsGeneratingGemini(true);
        setIsGeneratingImage_Dall_e_3(true);
        await generateAndDownloadYouTubeUploadInformation(firestoreResponseData);
        await callAPI(modelGemini, 'imageGeneration', firestoreResponseData, 'imageGenerationPrompt');
        console.log('Image Generation generatedDocID', generatedDocID);
        const idocRef = doc(db, 'genai', user.uid, 'MyGenAI', generatedDocID);
        const idocSnap = await getDoc(idocRef);
        if (idocSnap.exists()) {
            const ifirestoreResponseData = idocSnap.data().answer;
            console.log('Gen AI Image Generation - Second fetched data from Firestore:', ifirestoreResponseData);
            if (ifirestoreResponseData) {
                const parts = ifirestoreResponseData.match(/\[.*?\]/g)?.map(match => match.slice(1, -1)) || [];
                for (const part of parts) {
                    console.log('image prompt part:', part);
                    imageGenerationPromptInput = part;
                    if (generateGeminiImage === true) {
                        await callAPI(modelGeminiImage, 'image_ai_agent', imageGenerationPromptInput, 'image');
                    }
                    if (generateGptImage === true) {
                        await callAPI(modelGptImage, 'image_ai_agent', imageGenerationPromptInput, 'image');
                        console.log('Image generatedDocID:', generatedDocID);
                    }
                }
                setIsGeneratingImage_Dall_e_3(false);
            } else {
                console.error('ifirestoreResponseData is null or undefined');
            }
        }
        setIsGeneratingYouTubeAudioTitlePrompt(false);
    };
    // Sign Out
    const handleSignOut = () => {
        signOut(auth).catch((error) => {
            console.error('Error signing out:', error);
            alert('Error signing out: ' + error.message);
        });
    };

    // **New Event Handlers for Generate and Refresh**

    // Handler for Generate Button Click
    // **Handler for Generate Button Click**
    const handleGenerate = async () => {
        if (!promptInput.trim() && !isFileAttached) {
            alert('Please enter a prompt.');
            return;
        }

        // Check if at least one model is selected
        if (!isGpt && !isAnthropic && !isGemini && !isoMini && !iso1 && !isLlama && !isMistral && !isGptSearch && !isChatGPT && !isGeminiSearch && !isGeminiThink && !isPerplexityThink && !isPerplexity && !isCodestral && !isDeepSeekChat && !isDeepSeekThink && !isGroq && !isNova && !isCerebras && !isDeepSeek && !isGeminiThinkFast && !isClaudeThinking) {
            alert('Please select at least one model.');
            return;
        }

        if (isGroq && showGroq) {
            setIsGeneratingGroq(true); // Set generating state to true
            callAPI(modelGroq);
        }

        if (isDeepSeekThink && showDeepSeekThink) {
            setIsGeneratingDeepSeekThink(true); // Set generating state to true
            callAPI(modelDeepSeekThink);
        }

        if (isDeepSeekChat && showDeepSeekChat) {
            setIsGeneratingDeepSeekChat(true); // Set generating state to true
            callAPI(modelDeepSeekChat);
        }

        if (isClaudeThinking && showClaudeThinking) {
            setIsGeneratingClaudeThinking(true);
            callAPI(modelClaudeThinking);
        }

        // Generate API calls for each selected model
        if (isAnthropic && showAnthropic) {
            setIsGeneratingAnthropic(true); // Set generating state to true
            callAPI(modelAnthropic);
        }

        if (isGemini && showGemini) {
            setIsGeneratingGemini(true); // Set generating state to true
            callAPI(modelGemini);
        }
        if (isGpt && showGpt) {
            setIsGenerating(true); // Set generating state to true
            callAPI(modelGpt);
        }

        if (isoMini && showoMini) {
            setisGeneratingoMini(true); // Set generating state to true
            callAPI(modeloMini);
        }

        if (iso1 && showo) {
            setisGeneratingo(true); // Set generating state to true
            callAPI(modelo);
        }

        if (isLlama && showLlama) {
            setIsGeneratingLlama(true); // Set generating state to true
            callAPI(modelLlama);
        }

        if (isMistral && showMistral) {
            setIsGeneratingMistral(true); // Set generating state to true
            callAPI(modelMistral);
        }

        if (isChatGPT && showChatGPT) {
            setIsGeneratingChatGPT(true); // Set generating state to true
            callAPI(modelChatGPT);
        }

        if (isGeminiSearch && showGeminiSearch) {
            setIsGeneratingGeminiSearch(true); // Set generating state to true
            callAPI(modelGeminiSearch);
        }

        if (isGeminiThink && showGeminiThink) {
            setIsGeneratingGeminiFlash(true); // Set generating state to true
            callAPI(modelGeminiThink);
        }

        if (isGptSearch && showGptSearch) {
            setIsGeneratingGptSearch(true); // Set generating state to true
            callAPI(modelGptSearch);
        }

        if (isPerplexityThink && showPerplexityThink) {
            setIsGeneratingPerplexityThink(true); // Set generating state to true
            callAPI(modelPerplexityThink);
        }

        if (isPerplexity && showPerplexity) {
            setIsGeneratingPerplexity(true); // Set generating state to true
            callAPI(modelPerplexity);
        }

        if (isCodestral && showCodeStral) {
            setIsGeneratingCodeStral(true); // Set generating state to true
            callAPI(modelCodestralApi);
        }

        if (isNova && showNova) {
            setIsGeneratingNova(true); // Set generating state to true
            callAPI(modelNova);
        }
        if (isCerebras && showCerebras) {
            setIsGeneratingCerebras(true); // Set generating state to true
            callAPI(modelCerebras);
        }
        if (isDeepSeek && showDeepSeek) {
            setIsGeneratingDeepSeek(true);
            callAPI(modelDeepSeek);
        }
        if (isGeminiThinkFast && showGeminiThinkFast) {
            setIsGeneratingGeminiFlashFast(true);
            callAPI(modelGeminiThinkFast);
        }
    };

    const callAPI = async (selectedModel, invocationTypeParmeter = invocationType, inputText = '', sysPrompt = '', userPrompt = '') => {
        console.log('Calling API with model:', selectedModel, ' URL: ', process.env.REACT_APP_GENAI_API_URL);
        try {
            let response;
            let promptText = promptInput;
            if (inputText) {
                promptText = inputText;
            }
            if (isFileAttached) {
                promptText = attachmentInformation + autoPromptSeparator + promptText;
            }
            if (selectedPrompt) {
                userLevelPrompt = selectedPrompt;
            }
            if (sysPrompt) {
                systemLevelPrompt = sysPrompt;
            }
            if (userPrompt) {
                userLevelPrompt = userPrompt;
            }

            if (autoPrompt) {
                autoPromptNumber = 1;
                console.log('Auto Prompt Number:', autoPromptNumber);
            }

            console.log('temp:', temperatureRef.current.valueOf(), 'top_p:', top_pRef.current.valueOf());
            // Single API call with the determined promptText
            console.log('Prompt Text:', promptText);
            console.log('Model Name:', selectedModel);
            console.log('Invocation Type:', invocationTypeParmeter);
            console.log('user Level Prompt:', userLevelPrompt);
            console.log('System Level Prompt:', systemLevelPrompt);            // Determine promptText 
            response = await fetch(process.env.REACT_APP_GENAI_API_URL, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    prompt: promptText,
                    model: selectedModel,
                    uid: uid,
                    temperature: temperatureRef.current.valueOf(),
                    top_p: top_pRef.current.valueOf(),
                    invocationType: invocationTypeParmeter,
                    systemLevelPrompt: systemLevelPrompt,
                    userLevelPrompt: userLevelPrompt,
                    autoPromptNumber: autoPromptNumber,
                })
            });

            if (!response.ok) {
                const errorData = await response.json();
                alert(errorData.error + 'Failed to generate content');
                throw new Error(errorData.error || 'Failed to generate content.');
            }

            let data;
            data = await response.json();
            generatedDocID = data[0].results[0].docID;
            console.log('Generated Doc ID:', generatedDocID, '  invocationType:', invocationType);
            if (['practice_questions', 'quiz_with_choices', 'quiz'].includes(invocationType)) {
                setCurrentDocId(generatedDocID);
                console.log('currenDocID:', currentDocId);
                //setShowhomeWorkApp(true);
            }
            //console.log('Response:', data);
        } catch (error) {
            console.error('Error generating content:', error);
            alert(`Error: ${error.message}`);
        } finally {
            // click refresh button
            searchQuery = '';
            invocationType = '';
            searchModel = 'All';
            setIsGeneratingGeminiSearch(false);
            console.log('Fetching data after generating content');
            fetchData(userID);
            if (selectedModel === modelGpt) {
                setIsGenerating(false);
            }
            if (selectedModel === modelAnthropic) {
                setIsGeneratingAnthropic(false);
            }
            if (selectedModel === modelGemini) {
                setIsGeneratingGemini(false);
            }
            if (selectedModel === modeloMini) {
                setisGeneratingoMini(false);
            }
            if (selectedModel === modelo) {
                setisGeneratingo(false);
            }
            if (selectedModel === modelGptImage) {
                setIsGeneratingImage_Dall_e_3(false);
            }
            if (selectedModel === modelMistral) {
                setIsGeneratingMistral(false);
            }
            if (selectedModel === modelLlama) {
                setIsGeneratingLlama(false);
            }
            if (selectedModel === modelGptSearch) {
                setIsGeneratingGptSearch(false);
            }
            if (selectedModel === modelChatGPT) {
                setIsGeneratingChatGPT(false);
            }
            if (selectedModel === modelGeminiSearch) {
                setIsGeneratingGeminiSearch(false);
            }
            if (selectedModel === modelGeminiThink) {
                setIsGeneratingGeminiFlash(false);
            }
            if (selectedModel === modelPerplexityThink) {
                setIsGeneratingPerplexityThink(false);
            }
            if (selectedModel === modelPerplexity) {
                setIsGeneratingPerplexity(false);
            }
            if (selectedModel === modelCodestralApi) {
                setIsGeneratingCodeStral(false);
            }
            if (selectedModel === modelDeepSeekChat) {
                setIsGeneratingDeepSeekChat(false);
            }
            if (selectedModel === modelDeepSeekThink) {
                setIsGeneratingDeepSeekThink(false);
            }
            if (selectedModel === modelGroq) {
                setIsGeneratingGroq(false);
            }
            if (selectedModel === modelNova) {
                setIsGeneratingNova(false);
            }
            if (selectedModel === modelCerebras) {
                setIsGeneratingCerebras(false);
            }
            if (selectedModel === modelDeepSeek) {
                setIsGeneratingDeepSeek(false);
            }
            if (selectedModel === modelGeminiThinkFast) {
                setIsGeneratingGeminiFlashFast(false);
            }
            if (selectedModel === modelClaudeThinking) {
                setIsGeneratingClaudeThinking(false);
            }
            console.log('isGeneratingGeminiSearch:', isGeneratingGeminiSearch);
        }
    };

    // Function to call the TTS API
    const callTTSAPI = async (message, apiUrl) => {

        setIsGeneratingTTS(true); // Set generating state to true
        ttsVoiceName = voiceName;
        const cleanedArticles = message
            .replace(/https?:\/\/[^\s]+/g, '')
            .replace(/http?:\/\/[^\s]+/g, '')
            .replace(/[#:\-*]/g, ' ')
            .replace(/[&]/g, ' and ')
            .replace('```json', '')
            .replace(/[<>]/g, ' ')
            .replace(/\(\[[^\]]*\]\)/g, ' ')
            //       .replace(/["]/g, '&quot;')
            //       .replace(/[']/g, '&apos;')
            .trim();
        console.log('Calling TTS API with message:', cleanedArticles, ' voiceName:', voiceName);
        console.log('speechSilence:', speechSilenceRef.current.valueOf(), 'speechRate:', speechRateRef.current.valueOf());
        console.log('API URL:', apiUrl);
        if (!apiUrl) {
            console.error('API URL is not defined');
            return;
        }
        if (!cleanedArticles) {
            console.error('Cleaned articles are empty');
            return;
        }
        if (apiUrl.includes('geminitts')) {
            ttsVoiceName = googleTTSVoiceName;
        }
        try {
            const response = await fetch(apiUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    message: cleanedArticles,
                    uid: uid,
                    source: 'ai',
                    voice_name: ttsVoiceName,
                    chunk_size: chunk_size,
                    silence_break: speechSilenceRef.current.valueOf(),
                    prosody_rate: speechRateRef.current.valueOf()
                })
            });

            if (!response.ok) {
                throw new Error([`Network response was not ok: ${response.statusText}`]);
            }
            let data;
            // Try to get docID with retry logic
            let retries = 12;
            while (retries > 0) {
                data = await response.json();
                if (data[0]?.docID) {
                    // docID exists
                    break;
                }
                // Wait 2 seconds before retrying
                await new Promise(resolve => setTimeout(resolve, 2000));
                retries--;
                if (retries === 0) {
                    throw new Error('Failed to get document ID after multiple retries');
                }
            }
            ttsGeneratedDocID = data[0].docID;
        } catch (error) {
            console.error('Error calling TTS API:', error);
            alert([`Error: ${error.message}`]);
        } finally {
            setIsGeneratingTTS(false); // Reset generating state
            // Optionally, refresh data
            fetchData(uid);
        }
    };

    // Function to call the TTS API
    const callGenAITTSAPI = async (message) => {

        setIsGeneratingTTS(true); // Set generating state to true
        let genAIVoiceInstructions = voiceInstructions;
        const cleanedArticles = message
            .replace(/https?:\/\/[^\s]+/g, '')
            .replace(/http?:\/\/[^\s]+/g, '')
            .replace(/[#:\-*]/g, ' ')
            .replace(/[&]/g, ' and ')
            .replace('```json', '')
            .replace(/[<>]/g, ' ')
            .replace(/\(\[[^\]]*\]\)/g, ' ')
            //       .replace(/["]/g, '&quot;')
            //       .replace(/[']/g, '&apos;')
            .trim();
        console.log('Calling Gena AI TTS API with message:', cleanedArticles);
        console.log('selectedPromptFullText:', selectedPromptFullText);
        let genaiVoiceName = 'shimmer';
        if (voiceName.length < 9) {
            genaiVoiceName = voiceName;
        }
        if (selectedPromptFullText && selectedPromptFullText.includes("Pronunciation:")) {
            genAIVoiceInstructions = selectedPromptFullText;
        }
        try {
            const response = await fetch(process.env.REACT_APP_TTS_GENAI_API_URL, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    message: cleanedArticles,
                    uid: uid,
                    source: 'ai',
                    voice_name: genaiVoiceName,
                    chunk_size: 7900,
                    instructions: genAIVoiceInstructions,
                })
            });

            if (!response.ok) {
                throw new Error([`Network response was not ok: ${response.statusText}`]);
            }
            let data;
            // Try to get docID with retry logic
            let retries = 12;
            while (retries > 0) {
                data = await response.json();
                if (data[0]?.docID) {
                    // docID exists
                    break;
                }
                // Wait 2 seconds before retrying
                await new Promise(resolve => setTimeout(resolve, 2000));
                retries--;
                if (retries === 0) {
                    throw new Error('Failed to get document ID after multiple retries');
                }
            }
            ttsGeneratedDocID = data[0].docID;
        } catch (error) {
            console.error('Error calling TTS API:', error);
            alert([`Error: ${error.message}`]);
        } finally {
            setIsGeneratingTTS(false); // Reset generating state
            // Optionally, refresh data
            fetchData(uid);
        }
    };
    // Handler for TTS Checkbox Change
    const handleTTSChange = async () => {
        setIsGeneratingTTS(true);
        await callTTSAPI(promptInput, process.env.REACT_APP_TTS_SSML_API_URL);
        setIsGeneratingTTS(false);
    };
    // Add this helper function to handle LLM model selection
    const handleLLMChange = (setter, value) => {
        setter(value);
    };

    const vectorSearchResults = async () => {
        setIsLoading(true);
        console.log("Fetching data for Vector search query:", searchQuery);
        console.log("URL:", process.env.REACT_APP_GENAI_API_VECTOR_URL);
        fetch(process.env.REACT_APP_GENAI_API_VECTOR_URL, {
            method: "POST",
            body: JSON.stringify({
                uid: uid,
                q: searchQuery,
                limit: dataLimit,
            })
        })
            .then((res) => res.json())
            .then(async (data) => {
                const docIds = data.document_ids;
                const genaiCollection = collection(db, 'genai', uid, 'MyGenAI');
                const docsQuery = query(genaiCollection, where('__name__', 'in', docIds));
                const docsSnapshot = await getDocs(docsQuery);
                const genaiList = docsSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
                setGenaiData(genaiList);
                setIsLoading(false);
            })
            .catch((error) => {
                console.error("Error fetching data:", error);
                setIsLoading(false);
            });
    }

    const bigQueryResults = () => {
        setIsLoading(true);
        console.log("Fetching data for search query:", searchQuery);
        console.log("search model:", searchModel);
        console.log("limit:", dataLimit);
        console.log("URL:", process.env.REACT_APP_GENAI_API_BIGQUERY_URL);
        fetch(process.env.REACT_APP_GENAI_API_BIGQUERY_URL, {
            method: "POST",
            body: JSON.stringify({
                uid: uid,
                limit: dataLimit,
                q: searchQuery,
                model: searchModel,
                invocationType: invocationType
            })
        })
            .then((res) => res.json())
            .then((data) => {
                // Print data objects received from API
                data.forEach(item => {
                    console.log(item);
                });
                setGenaiData(data);
                setIsLoading(false);
            })
            .catch((error) => {
                console.error("Error fetching data:", error);
                setIsLoading(false);
            });
    }

    if (showhomeWorkApp) {  // Add this block
        return (
            <Homework
                user={user}
                onBack={() => setShowhomeWorkApp(false)}
                sourceDocumentID={currentDocId}
            />
        );
    }

    const handleDownload = async (mp3UrlText, modelName) => {
        setIsDownloading(true);
        try {
            const mp3FileUrl = mp3UrlText?.match(/\(([^)]+)\)/g)?.map(url => url.slice(1, -1));
            const proxyUrl = `https://genaiapp-892085575649.us-central1.run.app/proxy-download?url=${encodeURIComponent(mp3FileUrl)}`;
            const response = await fetch(proxyUrl);
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            const prefix = modelName === 'azure-tts' ? 'Audio_' : 'Image_';
            const extension = mp3FileUrl[0].substring(mp3FileUrl[0].lastIndexOf('.'));
            link.download = `${prefix}_${new Date().toISOString().slice(0, 19).replace(/[-:]/g, '_').replace('T', '__')}${extension}`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error('Download failed:', error);
        }
        finally {
            setIsDownloading(false);
        }
    };

    // Update saveReaction function to include docId
    const saveReaction = async (docId, reaction) => {
        try {
            const docRef = doc(db, 'genai', uid, 'MyGenAI', docId);
            await updateDoc(docRef, {
                reaction: reaction,
                updatedAt: new Date()
            });

            // Update local state to reflect the change
            const updatedData = genaiData.map(item => {
                if (item.id === docId) {
                    return { ...item, reaction: reaction };
                }
                return item;
            });
            setGenaiData(updatedData);
        } catch (error) {
            console.error('Error saving reaction:', error);
        }
    };

    const fetchTexts = async () => {
        let q;
        try {
            console.log('Fetching Texts from user collection');
            q = query(collection(db, 'genai', 'bTGBBpeYPmPJonItYpUOCYhdIlr1', 'prompts'), where('tag', '>', ''),
                where('fullText', '>', ''), orderBy('modifiedDateTime', 'asc'));

            const querySnapshot = await getDocs(q);
            querySnapshot.forEach((doc) => {
                const data = doc.data();
                //  console.log('fetchTexts Data:', data.tag, '    ', data.fullText);
                switch (data.tag) {
                    case 'autoPromptSeparator':
                        autoPromptSeparator = data.fullText;
                        break;
                    case 'voice_instructions':
                        voiceInstructions = data.fullText;
                        break;
                    default:
                        break;
                }
            });
        } catch (error) {
            console.error("Error fetching texts: ", error);
        }
    };

    // Function to fetch public configuration data
    const fetchPublicConfig = async (category) => {
        try {
            const configurationCollection = collection(db, 'public');
            let q;
            q = query(configurationCollection, where('setup', '==', category));
            // Fetch all documents in the 'public' collection for editing
            const configSnapshot = await getDocs(q);
            const configList = configSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            setConfigData(configList); // Store fetched data
            setShowConfigPopup(true); // Show the popup after fetching data
        } catch (error) {
            console.error("Error fetching public configuration: ", error);
            alert('Error fetching configuration: ' + error.message);
        }
    };

    // Function to handle starting the edit
    const handleEditConfig = (configItem) => {
        setEditingConfigId(configItem.id);
        // Pretty print JSON for editing
        setEditedConfigContent(JSON.stringify(configItem, null, 2));
    };

    // Function to handle saving the edited config
    const handleSaveConfig = async () => {
        if (!editingConfigId) return;

        try {
            const docRef = doc(db, 'public', editingConfigId);
            // Parse the edited JSON string back into an object
            const updatedData = JSON.parse(editedConfigContent);
            // Remove the id field before saving, as it's the document ID
            delete updatedData.id;
            await updateDoc(docRef, updatedData);
            alert('Configuration updated successfully!');
            setEditingConfigId(null); // Exit edit mode
            // fetchPublicConfig(); // Refresh the config data
        } catch (error) {
            console.error("Error updating configuration: ", error);
            // Check if the error is due to invalid JSON
            if (error instanceof SyntaxError) {
                alert('Error saving configuration: Invalid JSON format. Please check your changes.');
            } else {
                alert('Error saving configuration: ' + error.message);
            }
        }
    };

    // Function to cancel editing
    const handleCancelEditConfig = () => {
        setEditingConfigId(null);
        setEditedConfigContent('');
    };

    // Function to generate and download DOCX from Markdown
    const handleGenerateDocx = async (markdownText) => {
        if (!markdownText || !markdownText.trim()) {
            alert('Please enter some text to convert to Word.');
            return;
        }
        setIsGeneratingDocx(true);
        try {
            const processor = unified()
                .use(remarkParse)
                .use(remarkDocx, { output: 'blob' }); // Output as blob for file-saver

            const file = await processor.process(markdownText);
            const blob = await file.result;

            saveAs(blob, 'output.docx'); // Trigger download
            console.log('Successfully converted Markdown to DOCX and initiated download.');

        } catch (error) {
            console.error('Error during DOCX conversion:', error);
            alert(`Error converting to Word: ${error.message}`);
        } finally {
            setIsGeneratingDocx(false);
        }
    };

    // Create animatedComponents for react-select
    const animatedComponents = makeAnimated();

    // Create options array for LLM models
    const llmOptions = [
        showGpt && { value: labelGpt, label: labelGpt },
        showCerebras && { value: labelCerebras, label: labelCerebras },
        showGemini && { value: labelGemini, label: labelGemini },
        showAnthropic && { value: labelAnthropic, label: labelAnthropic },
        showGroq && { value: labelGroq, label: labelGroq },
        showMistral && { value: labelMistral, label: labelMistral },
        showChatGPT && { value: labelChatGPT, label: labelChatGPT },
        showNova && { value: labelNova, label: labelNova },
        showLlama && { value: labelLlama, label: labelLlama },
        showGptSearch && { value: labelGptSearch, label: labelGptSearch },
        showGeminiSearch && { value: labelGeminiSearch, label: labelGeminiSearch },
        showPerplexity && { value: labelPerplexity, label: labelPerplexity },
        showCodeStral && { value: labelCodestral, label: labelCodestral },
        showDeepSeekChat && { value: labelDeepSeekChat, label: labelDeepSeekChat },
        showDeepSeek && { value: labelDeepSeek, label: labelDeepSeek },
        showGeminiThinkFast && { value: labelGeminiThinkFast, label: labelGeminiThinkFast },
        showGeminiThink && { value: labelGeminiThink, label: labelGeminiThink },
        showClaudeThinking && { value: labelClaudeThinking, label: labelClaudeThinking },
        showo && { value: labelo, label: labelo },
        showPerplexityThink && { value: labelPerplexityThink, label: labelPerplexityThink },
        showoMini && { value: labeloMini, label: labeloMini },
        showDeepSeekThink && { value: labelDeepSeekThink, label: labelDeepSeekThink }
    ].filter(Boolean); // Filter out falsy values

    // Function to handle changes in the React Select component
    const handleLLMSelectChange = (selectedOptions) => {
        // Reset all states first
        setisGpt(false);
        setIsCerebras(false);
        setIsGemini(false);
        setIsAnthropic(false);
        setIsGroq(false);
        setIsMistral(false);
        setIsChatGPT(false);
        setIsNova(false);
        setIsLlama(false);
        setIsGptSearch(false);
        setIsGeminiSearch(false);
        setIsPerplexity(false);
        setIsCodestral(false);
        setIsDeepSeekChat(false);
        setIsDeepSeek(false);
        setIsGeminiThinkFast(false);
        setIsGeminiThink(false);
        setIsClaudeThinking(false);
        setIso1(false);
        setIsPerplexityThink(false);
        setIsoMini(false);
        setIsDeepSeekThink(false);

        // Set selected states
        if (selectedOptions) {
            selectedOptions.forEach(option => {
                if (option.value === labelGpt) setisGpt(true);
                if (option.value === labelCerebras) setIsCerebras(true);
                if (option.value === labelGemini) setIsGemini(true);
                if (option.value === labelAnthropic) setIsAnthropic(true);
                if (option.value === labelGroq) setIsGroq(true);
                if (option.value === labelMistral) setIsMistral(true);
                if (option.value === labelChatGPT) setIsChatGPT(true);
                if (option.value === labelNova) setIsNova(true);
                if (option.value === labelLlama) setIsLlama(true);
                if (option.value === labelGptSearch) setIsGptSearch(true);
                if (option.value === labelGeminiSearch) setIsGeminiSearch(true);
                if (option.value === labelPerplexity) setIsPerplexity(true);
                if (option.value === labelCodestral) setIsCodestral(true);
                if (option.value === labelDeepSeekChat) setIsDeepSeekChat(true);
                if (option.value === labelDeepSeek) setIsDeepSeek(true);
                if (option.value === labelGeminiThinkFast) setIsGeminiThinkFast(true);
                if (option.value === labelGeminiThink) setIsGeminiThink(true);
                if (option.value === labelClaudeThinking) setIsClaudeThinking(true);
                if (option.value === labelo) setIso1(true);
                if (option.value === labelPerplexityThink) setIsPerplexityThink(true);
                if (option.value === labeloMini) setIsoMini(true);
                if (option.value === labelDeepSeekThink) setIsDeepSeekThink(true);
            });
        }
    };

    return (
        <div>
            <div className={`main-content ${showEditPopup ? 'dimmed' : ''}`}>
                <div>
                    <TabList
                        value={outputType}
                        onChange={(newValue) => {
                            setOutputType(newValue);
                            if (newValue === 'text') {
                                setPlaceholderText(textPlaceHolderText);
                                setPromptSearchQuery('');
                                setAutoPrompt(false);
                                systemLevelPrompt = '';
                                invocationType = '';
                                userLevelPrompt = '';
                            } else if (newValue === 'code') {
                                setAutoPrompt(false);
                                systemLevelPrompt = '';
                                invocationType = '';
                                userLevelPrompt = '';
                            } else if (newValue === 'audio') {
                                setPlaceholderText(audioPlaceHolderText);
                                setPromptSearchQuery('');
                                setAutoPrompt(false);
                                systemLevelPrompt = '';
                                invocationType = '';
                                userLevelPrompt = '';
                            } else if (newValue === 'image') {
                                setPlaceholderText(imagePlaceHolderText);
                                setPromptSearchQuery('');
                                setAutoPrompt(false);
                                systemLevelPrompt = '';
                                invocationType = '';
                                userLevelPrompt = '';
                            } else if (newValue === 'diagrams') {
                                setPlaceholderText(diagramsPlaceHolderText);
                                setPromptSearchQuery('svg-geometry');
                                setAutoPrompt(false);
                                systemLevelPrompt = 'svg-geometry';
                                invocationType = 'svg-geometry';
                                userLevelPrompt = '';
                            } else if (newValue === 'charts') {
                                setPlaceholderText(chartsPlaceHolderText);
                                setPromptSearchQuery('svg-dashboards');
                                setAutoPrompt(false);
                                systemLevelPrompt = 'svg-dashboards';
                                invocationType = 'svg-dashboards';
                                userLevelPrompt = '';
                            } else if (newValue === 'workflow') {
                                setPlaceholderText(workflowPlaceHolderText);
                                setPromptSearchQuery('draw-io');
                                setAutoPrompt(false);
                                systemLevelPrompt = 'draw-io';
                                invocationType = 'draw-io';
                                userLevelPrompt = '';
                            } else if (newValue === '3DModel') {
                                setPlaceholderText(threeDModelPlaceHolderText);
                                setPromptSearchQuery('3D_Model');
                                setAutoPrompt(false);
                                systemLevelPrompt = '3D_Model';
                                invocationType = '3D_Model';
                                userLevelPrompt = '';
                            } else if (newValue === 'agents') {
                                setPlaceholderText(agentsPlaceHolderText);
                                setPromptSearchQuery('');
                                setAutoPrompt(false);
                                systemLevelPrompt = '';
                                invocationType = '';
                                userLevelPrompt = '';
                            }

                        }}
                    />
                    <textarea
                        className="promptInput"
                        value={promptInput}
                        onChange={(e) => setPromptInput(e.target.value)}
                        placeholder={placeholderText}
                    />
                </div>
                <div style={{ marginBottom: '20px' }}>
                    &nbsp;
                    <div style={{ position: 'relative', display: 'inline-block', marginRight: '10px' }}>
                        <button
                            className="action_button"
                            onClick={() => setIsAppsMenuOpen(!isAppsMenuOpen)}
                        >
                            Apps ☰
                        </button>

                        {isAppsMenuOpen && (
                            <div style={{
                                position: 'absolute',
                                top: '100%',
                                left: 0,
                                zIndex: 1000,
                                backgroundColor: 'white',
                                border: '1px solid #ddd',
                                borderRadius: '4px',
                                boxShadow: '6px 6px 6px rgba(0,0,0,0.2)',
                                width: '250px',
                            }}>
                                                                <div style={{ padding: '8px 0' }}>
                                    <button
                                        className="action_button"
                                        style={{ width: '100%', textAlign: 'left', margin: '5px 0' }}
                                        onClick={() => window.open('https://genai-tutor.com', '_blank')}
                                    >
                                        Homework Explain/Practice
                                    </button>
                                    <button
                                        className="action_button"
                                        style={{ width: '100%', textAlign: 'left', margin: '5px 0' }}
                                        onClick={() => window.open('https://maths-operations.web.app', '_blank')}
                                    >
                                        Calculations + - x / %
                                    </button>
                                    <button
                                        className="action_button"
                                        style={{ width: '100%', textAlign: 'left', margin: '5px 0' }}
                                        onClick={() => window.open('https://listsoftasks.com', '_blank')}
                                    >
                                        Task List
                                    </button>
                                    <button
                                        className="action_button"
                                        style={{ width: '100%', textAlign: 'left', margin: '5px 0' }}
                                        onClick={() => window.open(`${window.location.origin}/?app=AudioApp`, '_blank')}
                                    >
                                        Audio Player
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>

                    {isUploading && (
                        <FaSpinner className="spinning" />
                    )}
                    {(outputType === 'workflow') && (
                        <>
                            <input
                                type="file"
                                accept=".jpg,.jpeg,.png,.gif,.webp"
                                className="fileInput"
                                style={{ marginLeft: '6px', marginBottom: '6px', padding: '2px', fontSize: '18px' }}
                                onChange={async (e) => {
                                    const file = e.target.files[0];
                                    if (file) {
                                        const formData = new FormData();
                                        formData.append('file', file);
                                        formData.append('uid', uid);
                                        formData.append('filename', file.name);
                                        const fileExtension = file.name.split('.').pop().toLowerCase();
                                        console.log('File extension:', fileExtension);
                                        try {

                                            const fileExtensions = ['jpg', 'jpeg', 'png', 'gif', 'webp'];
                                            let invocation = 'jpeg';
                                            if (fileExtension === 'png') {
                                                invocation = 'png';
                                            }
                                            if (fileExtension === 'gif') {
                                                invocation = 'gif';
                                            }
                                            if (fileExtension === 'webp') {
                                                invocation = 'webp';
                                            }
                                            if (fileExtensions.includes(fileExtension)) {
                                                const reader = new FileReader();
                                                reader.onload = async (event) => {
                                                    const dataUrl = event.target.result;
                                                    const base64_image = dataUrl.substring(dataUrl.indexOf(',') + 1); // Extract base64 data after the comma
                                                    console.log('Base64 Image extracted.'); // Log confirmation, avoid logging the potentially large string
                                                    setIsGeneratingClaudeThinking(true);
                                                    await callAPI('claude-image', invocation, base64_image);
                                                    setIsGeneratingClaudeThinking(false);
                                                };
                                                reader.readAsDataURL(file);

                                            }

                                        } catch (error) {
                                            console.error('Error uploading document:', error);
                                            alert(`Error: ${error.message}`);
                                        }
                                    }
                                }}
                            />
                        </>
                    )}
                    {(outputType !== 'workflow') && (
                        <input
                            type="file"
                            style={{ marginLeft: '6px', marginBottom: '6px', padding: '2px', fontSize: '18px' }}
                            onChange={async (e) => {
                                const file = e.target.files[0];
                                if (file) {
                                    const formData = new FormData();
                                    formData.append('file', file);
                                    formData.append('uid', uid);
                                    formData.append('filename', file.name);
                                    const fileExtension = file.name.split('.').pop().toLowerCase();
                                    console.log('File extension:', fileExtension);
                                    try {
                                        const fileExtensions = ['pdf', 'doc', 'docx', 'xlsx', 'xls', 'ppt', 'pptx', 'jpg', 'jpeg', 'png', 'webp', 'gif'];
                                        if (fileExtensions.includes(fileExtension)) {
                                            console.log('Uploading document:', file.name);
                                            setIsUploading(true); // Show spinning wheel
                                            const response = await fetch(`${process.env.REACT_APP_GENAI_API_URL}md`, {
                                                method: 'POST',
                                                body: formData
                                            });

                                            if (!response.ok) {
                                                const errorData = await response.json();
                                                setIsUploading(false); // Hide spinning wheel
                                                throw new Error(errorData.error || 'Failed to upload document.');
                                            }
                                            const data = await response.json();
                                            attachmentInformation = data.markdown;
                                            console.log('Markitdown File content:', attachmentInformation);
                                            alert('Document uploaded successfully. Please select option below or enter prompt in above text box, and click on the GenAI button to generate the document.');
                                            setIsUploading(false); // Hide spinning wheel
                                            setIsFileAttached(true);
                                            fetchData(uid);
                                        }
                                        else {
                                            const reader = new FileReader();
                                            reader.onload = async (event) => {
                                                const content = event.target.result;
                                                attachmentInformation = content;
                                                //wrap attachmentInformation in triple backticks and add new line character after each line
                                                attachmentInformation = ' ::: Information from the attached file is below ::: \n ``` \n' + attachmentInformation.replace(/(\r\n|\n|\r)/g, '\n') + '``` \n';
                                                console.log('File content:', attachmentInformation);
                                                setIsFileAttached(true);
                                            };
                                            reader.readAsText(file);

                                        }

                                    } catch (error) {
                                        console.error('Error uploading document:', error);
                                        alert(`Error: ${error.message}`);
                                    }
                                }
                            }}
                        />

                    )}
                    {(outputType !== 'audio') && (outputType !== 'image') && (outputType !== 'agents') && (
                        <>
                            <button
                                onClick={() => handleGenerate()}
                                className={
                                    isGenerating ||
                                        isGeneratingGemini ||
                                        isGeneratingAnthropic ||
                                        isGeneratingoMini ||
                                        isGeneratingo ||
                                        isGeneratingImage_Dall_e_3 ||
                                        isGeneratingTTS ||
                                        isGeneratingMistral ||
                                        isGeneratingLlama ||
                                        isGeneratingGptSearch ||
                                        isGeneratingGeminiSearch ||
                                        isGeneratingGeminiFlash ||
                                        isGeneratingPerplexity ||
                                        isGeneratingPerplexityThink ||
                                        isGeneratingCodeStral ||
                                        isGeneratingChatGPT ||
                                        isGeneratingDeepSeekChat ||
                                        isGeneratingDeepSeekThink ||
                                        isGeneratingGroq ||
                                        isGeneratingNova ||
                                        isGeneratingCerebras ||
                                        isGeneratingDeepSeek ||
                                        isGeneratingGeminiFlashFast || isGeneratingClaudeThinking || isGeneratingDocx ? 'action_button_flashing' : 'action_button'
                                }
                                style={{ backgroundColor: 'lightblue', color: 'black', fontSize: '22px', fontWeight: 'bold' }}
                                disabled={
                                    isGenerating ||
                                    isGeneratingGemini ||
                                    isGeneratingAnthropic ||
                                    isGeneratingoMini ||
                                    isGeneratingo ||
                                    isGeneratingImage_Dall_e_3 ||
                                    isGeneratingTTS ||
                                    isGeneratingMistral ||
                                    isGeneratingLlama ||
                                    isGeneratingGptSearch ||
                                    isGeneratingGeminiSearch ||
                                    isGeneratingGeminiFlash ||
                                    isGeneratingPerplexity ||
                                    isGeneratingPerplexityThink ||
                                    isGeneratingCodeStral ||
                                    isGeneratingChatGPT ||
                                    isGeneratingDeepSeekChat ||
                                    isGeneratingDeepSeekThink ||
                                    isGeneratingGroq ||
                                    isGeneratingNova ||
                                    isGeneratingCerebras ||
                                    isGeneratingDeepSeek ||

                                    isGeneratingGeminiFlashFast ||
                                    isGeneratingClaudeThinking ||
                                    isGeneratingDocx
                                }
                            >
                                <strong>GenAI</strong>
                            </button>
                        </>
                    )
                    }
                    {(outputType === 'image') &&
                        <button
                            className={isGeneratingImages ? 'action_button_flashing' : 'action_button'}
                            style={{ backgroundColor: 'lightblue', color: 'black', fontSize: '22px', fontWeight: 'bold' }}
                            onClick={async () => {
                                if (promptInput === undefined || promptInput.length < 5) {
                                    alert('ERROR: prompt is blank.');
                                    return;
                                }
                                setTemperature(1);
                                setTop_p(1);
                                // Need to wait for state updates to be applied
                                await new Promise(resolve => setTimeout(resolve, 500));
                                setIsGeneratingImages(true);
                                try {
                                    imageGenerationPromptInput = promptInput;
                                    if (generateGptImage === true) {
                                        await callAPI(modelGptImage, 'image_ai_agent', imageGenerationPromptInput);
                                    }
                                    if (generateGeminiImage === true) {
                                        await callAPI(modelGeminiImage, 'image_ai_agent', imageGenerationPromptInput);
                                    }
                                    setIsGeneratingImages(false);
                                }
                                catch (error) {
                                    console.error("Error fetching questions from Firestore:", error);
                                    setIsGeneratingImages(false);
                                    return null;
                                }
                            }}>
                            {genai_image_label || 'GenAI Image'}
                        </button>
                    }
                    {(outputType === 'audio') && (
                        <button
                            className={isLiveAudioPlayingPrompt ? 'action_button_flashing' : 'action_button'}
                            style={{ backgroundColor: 'lightblue', color: 'black', fontSize: '22px', fontWeight: 'bold' }}
                            onClick={async () => {
                                try {
                                    setIsLiveAudioPlayingPrompt(true);
                                    await synthesizeSpeech(promptInput, "English");
                                } catch (error) {
                                    console.error('Error playing audio:', error);
                                }
                                finally {
                                    setIsLiveAudioPlayingPrompt(false);
                                }
                            }}
                        >
                            <FaPlay /> Speak
                        </button>
                    )
                    }
                    {(outputType === 'agents') && (
                        <>
                            {
                                (<button
                                    className={
                                        (isGeneratingYouTubeAudioTitlePrompt) ?
                                            'action_button_flashing' : 'action_button'
                                    }
                                    onClick={async () => {
                                        setTemperature(0.8);
                                        setTop_p(0.8);
                                        setIsGeneratingYouTubeAudioTitlePrompt(true);
                                        await new Promise(resolve => setTimeout(resolve, 500));
                                        await callAPI(modelo, 'youtube', promptInput, 'YouTube');
                                        //console.log(' generatedDocID', generatedDocID);
                                        if (!generatedDocID || generatedDocID.length < 5) {
                                            alert('ERROR: generatedDocID is not set.');
                                            return;
                                        }
                                        try {
                                            const docRef = doc(db, 'genai', user.uid, 'MyGenAI', generatedDocID);
                                            const docSnap = await getDoc(docRef);

                                            if (docSnap.exists()) {
                                                const firestoreResponseData = docSnap.data().answer;
                                                //  console.log('First fetched data from Firestore:', firestoreResponseData);
                                                if (firestoreResponseData === undefined || firestoreResponseData.length < 100) {
                                                    alert('ERROR: Prompt response is not generated.');
                                                    return;
                                                }
                                                setSpeechRate(youtubeSpeecRate);
                                                setSpeechSilence(youtubeSpeechSilence);
                                                // Need to wait for state updates to be applied
                                                await new Promise(resolve => setTimeout(resolve, 500));

                                                generateYouTubeUploadInformation(firestoreResponseData);
                                            }
                                            return null;
                                        }
                                        catch (error) {
                                            console.error("Error fetching questions from Firestore:", error);
                                            return null;
                                        }

                                    }}>
                                    <label>
                                        {genai_youtube_label || 'YouTube'}
                                    </label>
                                </button>
                                )
                            }
                            <button
                                className={isGeneratingYouTubeMusic ? 'action_button_flashing' : 'action_button'}
                                onClick={async () => {
                                    if (promptInput === undefined || promptInput.length < 5) {
                                        alert('ERROR: prompt is blank.');
                                        return;
                                    }
                                    setTemperature(1);
                                    setTop_p(1);
                                    // Need to wait for state updates to be applied
                                    await new Promise(resolve => setTimeout(resolve, 500));

                                    setIsGeneratingYouTubeMusic(true);
                                    try {
                                        await generateYouTubeUploadInformation(promptInput, 'youtube_own_content');
                                        setIsGeneratingYouTubeMusic(false);
                                    }
                                    catch (error) {
                                        console.error("Error fetching questions from Firestore:", error);
                                        return null;
                                    }
                                }}
                            >
                                Title/Description/Audio/Images
                            </button>
                        </>
                    )}
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    {(outputType !== 'audio') && (outputType !== 'image') && (outputType !== 'agents') && (showSettings) && (<button className={autoPrompt ? 'action_button_selected' : 'action_button'} onClick={() => setAutoPrompt(!autoPrompt)}>
                        {genai_autoprompt_label || 'AutoPrompt'}
                    </button>
                    )}
                    &nbsp;&nbsp;
                    <button className='action_button' onClick={() => setShowSettings(!showSettings)}>
                        <FaSlidersH />
                    </button>
                    {(uid === 'bTGBBpeYPmPJonItYpUOCYhdIlr1') && (<button onClick={() => fetchPublicConfig('genaiAdmin')} className="action_button">
                        <FaCog />
                    </button>)}
                    <button
                        className={isRefreshing ? 'action_button_flashing' : 'action_button'}
                        onClick={async () => {
                            const currentUser = auth.currentUser;
                            if (currentUser) {
                                setIsRefreshing(true);
                                await fetchData(currentUser.uid);
                                await fetchPrompts(currentUser.uid);
                                await fetchGenAIParameters(currentUser.uid);
                                await fetchTexts();
                                setIsRefreshing(false);
                            } else {
                                alert('No user is signed in');
                            }
                        }}
                    >
                        <FaSyncAlt />
                    </button>
                    &nbsp;&nbsp;
                    &nbsp;&nbsp;
                    <button className='action_button' onClick={handleSignOut}><FaSignOutAlt /> </button>
                    {user && <span style={{ marginLeft: '5px' }}> {user.email}
                    </span>
                    }
                    <br />
                    <div style={{ marginLeft: '5px', fontSize: '12px', display: 'flex', flexDirection: 'row' }}>
                        <div style={{ flex: 1, marginRight: '10px' }}>
                            {(outputType === 'audio') && (
                                <>
                                    < br />
                                    <VoiceSelect
                                        selectedVoice={voiceName} // Current selected voice
                                        onVoiceChange={setVoiceName} // Handler to update selected voice
                                    />
                                    <div style={{ display: 'inline-block' }}>
                                        <label style={{ marginLeft: '8px' }}>
                                            Speech Rate:
                                            <input
                                                type="text"
                                                maxLength="5"
                                                value={speechRate}
                                                onChange={(e) => setSpeechRate(e.target.value)}
                                                style={{ width: '50px', marginLeft: '5px' }}
                                            />
                                        </label>
                                        <label style={{ marginLeft: '8px' }}>
                                            Speech Silence:
                                            <input
                                                type="number"
                                                value={speechSilence}
                                                onChange={(e) => setSpeechSilence(parseInt(e.target.value))}
                                                style={{ width: '60px', marginLeft: '5px' }}
                                            />
                                        </label>
                                        {(outputType === 'audio') &&
                                            <button
                                                className={isGeneratingTTS ? 'action_button_flashing' : 'action_button'}
                                                onClick={() => handleTTSChange()}
                                            >
                                                <FaCloudDownloadAlt /> {genai_audio_label || 'Audio'}
                                            </button>
                                        }
                                        {(outputType === 'audio') &&
                                            <button
                                                className={isGeneratingTTS ? 'action_button_flashing' : 'action_button'}
                                                onClick={() => { callTTSAPI(promptInput, process.env.REACT_APP_TTS_GEMINI_API_URL); }}
                                            >
                                                <FaCloudDownloadAlt /> Gemini Audio
                                            </button>
                                        }                              {(outputType === 'audio') &&
                                            <button
                                                className={isGeneratingTTS ? 'action_button_flashing' : 'action_button'}
                                                onClick={() => callGenAITTSAPI(promptInput)}
                                            >
                                                <FaCloudDownloadAlt /> Gen AI Audio
                                            </button>
                                        }

                                    </div>
                                </>
                            )}

                            {(outputType !== 'audio') && (outputType !== 'image') && (outputType !== 'agents') && <Select
                                closeMenuOnSelect={false}
                                components={animatedComponents}
                                isMulti
                                options={llmOptions}
                                onChange={handleLLMSelectChange}
                                placeholder="Select LLM Models"
                                className="llm-select"
                                classNamePrefix="llm-select"
                                value={llmOptions.filter(option =>
                                    (isGpt && option.value === labelGpt) ||
                                    (isCerebras && option.value === labelCerebras) ||
                                    (isGemini && option.value === labelGemini) ||
                                    (isAnthropic && option.value === labelAnthropic) ||
                                    (isGroq && option.value === labelGroq) ||
                                    (isMistral && option.value === labelMistral) ||
                                    (isChatGPT && option.value === labelChatGPT) ||
                                    (isNova && option.value === labelNova) ||
                                    (isLlama && option.value === labelLlama) ||
                                    (isGptSearch && option.value === labelGptSearch) ||
                                    (isGeminiSearch && option.value === labelGeminiSearch) ||
                                    (isPerplexity && option.value === labelPerplexity) ||
                                    (isCodestral && option.value === labelCodestral) ||
                                    (isDeepSeekChat && option.value === labelDeepSeekChat) ||
                                    (isDeepSeek && option.value === labelDeepSeek) ||
                                    (isGeminiThinkFast && option.value === labelGeminiThinkFast) ||
                                    (isGeminiThink && option.value === labelGeminiThink) ||
                                    (isClaudeThinking && option.value === labelClaudeThinking) ||
                                    (iso1 && option.value === labelo) ||
                                    (isPerplexityThink && option.value === labelPerplexityThink) ||
                                    (isoMini && option.value === labeloMini) ||
                                    (isDeepSeekThink && option.value === labelDeepSeekThink)
                                )}
                            />
                            }
                        </div>
                        <div style={{ flex: 1 }}>
                            {(outputType !== 'audio') && (outputType !== 'image') && (outputType !== 'agents') && <Select
                                closeMenuOnSelect={false}
                                components={animatedComponents}
                                isMulti
                                options={predefinedPrompts.map(p => ({ value: p.tag, label: p.tag }))}
                                onChange={(selectedOptions) => {
                                    if (selectedOptions && selectedOptions.length > 0) {
                                        const tags = selectedOptions.map(option => option.value);
                                        systemLevelPrompt = tags[0];
                                        invocationType = tags[0]; // Use first selected tag as invocation type
                                        setPromptSearchQuery(tags.join(','));
                                        setShowSearchQuery(false);
                                    } else {
                                        setPromptSearchQuery('');
                                        setShowSearchQuery(true);
                                        systemLevelPrompt = '';
                                        invocationType = '';
                                    }
                                }}
                                placeholder="Search prompts..."
                                className="llm-select"
                                classNamePrefix="llm-select"
                                value={promptSearchQuery ? promptSearchQuery.split(',').map(tag => ({ value: tag, label: tag })) : []}
                                isClearable
                                onMenuOpen={() => {
                                    setShowSearchQuery(true);
                                }}
                            />}
                        </div>
                        {isUploading && (
                            <FaSpinner className="spinning" />
                        )}

                    </div>
                    <br />
                    {showSettings && (
                        <>
                            {showTemp && (
                                <>
                                    <label style={{ marginLeft: '8px' }}>
                                        Temp:
                                        <input
                                            type="number"
                                            value={temperature}
                                            onChange={(e) => setTemperature(parseFloat(e.target.value))}
                                            step="0.1"
                                            min="0"
                                            max="1"
                                            style={{ width: '50px', marginLeft: '5px' }}
                                        />
                                    </label>
                                </>
                            )}
                            {showTop_p && (
                                <label style={{ marginLeft: '8px' }}>
                                    Top_p:
                                    <input
                                        type="number"
                                        value={top_p}
                                        onChange={(e) => setTop_p(parseFloat(e.target.value))}
                                        step="0.1"
                                        min="0"
                                        max="1"
                                        style={{ width: '50px', marginLeft: '5px' }}
                                    />
                                </label>
                            )}
                            &nbsp;
                            {showPromptsDropDown && (
                                <select className="promptDropdownInput" id="promptSelect"
                                    onChange={(e) => {
                                        setSelectedPrompt(e.target.options[e.target.selectedIndex].text);
                                        setSelectedPromptFullText(e.target.value);
                                    }}
                                    style={{ marginLeft: '2px', padding: '2px', fontSize: '16px' }}
                                >
                                    <option value="NA">Select Prompt</option>
                                    {genaiPrompts.map((prompt) => (
                                        <option key={prompt.id} value={prompt.fullText}>{prompt.tag}</option>
                                    ))}
                                </select>
                            )}
                            {showEditPromptButton && <button
                                className="action_button"
                                onClick={() => {
                                    setShowPromptEditor(true);
                                }}
                            >
                                Add/Edit Prompts
                            </button>
                            }
                            <br />
                            <br />
                            <label>
                                Limit:
                                <input
                                    className="limitInput"
                                    type="number"
                                    onBlur={(event) => handleLimitChange(event)}
                                    onKeyDown={(event) => (event.key === "Enter" || event.key === "Tab") && handleLimitChange(event)}
                                    defaultValue={dataLimit}
                                    min={1}
                                />
                            </label>
                            <input
                                className="searchInput"
                                type="text"
                                onKeyDown={(event) => (event.key === "Enter" || event.key === "Tab") && handleVectorSearchChange(event)}
                                placeholder="Semantic Search"
                            />
                            <input
                                className="searchInput"
                                type="text"
                                onKeyDown={(event) => (event.key === "Enter" || event.key === "Tab") && handleSearchChange(event)}
                                placeholder="Keyword Search"
                            />
                            <select
                                className="searchInput"
                                onChange={(event) => handleInvocationChange(event)}
                                defaultValue=""
                                style={{ marginLeft: '2px', padding: '2px', fontSize: '16px' }}
                            >
                                <option value="">Select Invocation Type</option>
                                <option value="homeWork">Practice Questions</option>
                                <option value="quiz">Trivia / Quiz</option>
                                <option value="image">Image</option>
                                <option value="youtube">YouTube Content</option>
                                <option value="youtubeTitle">YouTube Title</option>
                                <option value="youtubeDescription">YouTube Description</option>
                                <option value="bedtime_stories">Bedtime Stories</option>
                                <option value="quiz_with_choices">Multiple Choice Quiz</option>
                                <option value="explain">Explain</option>
                                <option value="lyrics">Lyrics</option>
                                <option value="google-search">Google Search</option>
                                <option value="image_ai_agent">Image AI Agent</option>
                                <option value="imageGeneration">Image Generation Prompts</option>
                                <option value="GenAI">Gen AI Button</option>
                                <option value="svg-geometry">SVG Geometry</option>
                                <option value="svg-dashboards">SVG Dashboards</option>
                                <option value="draw-io">Draw.io</option>
                                <option value="3D_Model">3D Model</option>
                                <option value="practice_questions">Practice Questions</option>
                                <option value="answer">Answer with Steps</option>
                                <option value="quiz">Quiz</option>
                                <option value="mom">MOM</option>
                                <option value="Feedback">Feedback</option>
                                <option value="Summary">Summary</option>
                            </select>

                        </>
                    )}
                    {showPromptEditor && (
                        <PromptEditor onClose={async () => { await fetchPrompts(uid);
                            setShowPromptEditor(false);}} />
                    )}
                    {showConfigPopup && !isLoading && (
                        <div className="modal-overlay">
                            <div className="modal-content" style={{ maxHeight: '80vh', overflowY: 'auto' }}>
                                <h3>Public Configuration</h3>
                                {configData.length > 0 ? (
                                    configData.map(configItem => (
                                        <div key={configItem.id} style={{ marginBottom: '15px', borderBottom: '1px solid #eee', paddingBottom: '10px' }}>
                                            <h4>Document ID: {configItem.id}</h4>
                                            <pre style={{ whiteSpace: 'pre-wrap', wordWrap: 'break-word', background: '#f9f9f9', padding: '10px', borderRadius: '5px' }}>
                                                {JSON.stringify(configItem, (key, value) => {
                                                    // Optional: Format specific fields like dates if needed
                                                    if (value && typeof value === 'object' && value.seconds !== undefined) {
                                                        return new Date(value.seconds * 1000).toLocaleString();
                                                    }
                                                    return value;
                                                }, 2)}
                                            </pre>
                                            {editingConfigId === configItem.id ? (
                                                <div>
                                                    <textarea
                                                        value={editedConfigContent}
                                                        onChange={(e) => setEditedConfigContent(e.target.value)}
                                                        rows="10"
                                                        style={{ width: '100%', marginTop: '10px', fontFamily: 'monospace' }}
                                                    />
                                                    <button onClick={handleSaveConfig} className="signinbutton">Save</button>
                                                    <button onClick={handleCancelEditConfig} className="signoutbutton">Cancel</button>
                                                </div>
                                            ) : (
                                                <button onClick={() => handleEditConfig(configItem)} className="action_button">
                                                    Edit
                                                </button>
                                            )}
                                        </div>
                                    ))
                                ) : (
                                    <p>No configuration data found.</p>
                                )}
                                <button onClick={() => setShowConfigPopup(false)} className="signoutbutton">Close</button>
                                <br /><br />
                            </div>
                        </div>
                    )}

                    <div>
                        {isLoading && <p> Loading Data...</p>}
                        {!isLoading && <div>
                            {genaiData.map((item) => (
                                <div className="outputDetailsFormat" key={item.createdDateTime}>
                                    <div className="responseFormat">
                                        <h4 style={{ color: "brown" }}>

                                            <span style={{ color: "#a3780a", fontWeight: "bold" }}> Response </span>
                                            {item.llm && item.llm !== 'default' && item.llm !== '' && (
                                                <span style={{ color: "blue", fontSize: "16px" }}>({item.llm})</span>
                                            )}
                                            &nbsp;
                                            @ <span style={{ color: "black", fontSize: "16px" }}>{new Date(item.createdDateTime).toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })}</span>
                                            &nbsp;

                                            on <span style={{ color: "grey", fontSize: "16px" }}>{new Date(item.createdDateTime).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</span>
                                            &nbsp;&nbsp;
                                            <span style={{ color: "blue", fontSize: "16px" }}>{item.model}</span>

                                            &nbsp;
                                            {showPrint && showSettings && (<button onClick={() => {
                                                const updatedData = genaiData.map(dataItem => {
                                                    if (dataItem.id === item.id) {
                                                        return { ...dataItem, showRawQuestion: !dataItem.showRawQuestion };
                                                    }
                                                    return dataItem;
                                                });
                                                setGenaiData(updatedData);
                                            }}>
                                                {item.showRawQuestion ? <FaMarkdown /> : <FaEnvelopeOpenText />}
                                            </button>
                                            )}
                                            &nbsp; &nbsp;
                                            {showPrint && showSettings && (<span style={{ color: "black", fontSize: "12px" }}>  #Char(Q): </span>
                                            )}                                     {showPrint && showSettings && (<span style={{ color: "darkblue", fontSize: "16px" }}> {item.question?.length || 0}
                                            </span>)}
                                        </h4>
                                        <div style={{ fontSize: '16px' }}>
                                            {item.showRawQuestion ? item.question : (showFullQuestion[item.id] ? <ReactMarkdown>{item.question}</ReactMarkdown> : <ReactMarkdown>{getQuestionSubstring(item.question)}</ReactMarkdown>)}
                                        </div>
                                        {showPrint && (<button onClick={() => {
                                            setShowFullQuestion(prev => ({
                                                ...prev,
                                                [item.id]: !prev[item.id]
                                            }));
                                        }}>            {showFullQuestion[item.id] ? 'Less' : 'More'}
                                        </button>
                                        )}

                                    </div>
                                    <div style={{ border: "1px solid black" }}>
                                        <div style={{ color: "green", fontWeight: "bold" }}>

                                            {item.model !== modelGptImage && item.model !== modelGeminiImage && item.model !== 'azure-tts' && (
                                                <>
                                                    {(!isiPhone && showPrint && showSettings && (!item.voiceName || !item.voiceName?.length > 2) &&
                                                        <button
                                                            className={isLiveAudioPlaying[item.id] ? 'action_button_flashing' : 'action_button'}
                                                            onClick={async () => {
                                                                try {
                                                                    setIsLiveAudioPlaying(prev => ({ ...prev, [item.id]: true }));
                                                                    await synthesizeSpeech(item.answer, item.language || "English");

                                                                } catch (error) {
                                                                    console.error('Error playing audio:', error);
                                                                }
                                                                finally {
                                                                    setIsLiveAudioPlaying(prev => ({ ...prev, [item.id]: false }));
                                                                }
                                                            }}
                                                        >
                                                            <label className={isLiveAudioPlaying[item.id] ? 'flashing' : ''}>
                                                                <FaPlay /> Speak
                                                            </label>
                                                        </button>
                                                    )}

                                                    <button
                                                        className={isGeneratingDocx ? 'action_button_flashing' : 'action_button'}
                                                        onClick={() => handleGenerateDocx(item.answer)}
                                                        disabled={isGeneratingDocx}
                                                    >
                                                        <FaCloudDownloadAlt /> Microsoft Word
                                                    </button>

                                                </>
                                            )}
                                            &nbsp; &nbsp; &nbsp;
                                            {showPrint && showSettings && (<button onClick={() => {
                                                const updatedData = genaiData.map(dataItem => {
                                                    if (dataItem.id === item.id) {
                                                        return { ...dataItem, showRawAnswer: !dataItem.showRawAnswer };
                                                    }
                                                    return dataItem;
                                                });
                                                setGenaiData(updatedData);
                                            }}>
                                                {item.showRawAnswer ? <FaMarkdown /> : <FaEnvelopeOpenText />}
                                            </button>
                                            )}
                                            &nbsp; &nbsp;
                                            {showPrint && showSettings && (<span style={{ color: "black", fontSize: "12px", fontWeight: "normal" }}> #Char(Ans):</span>
                                            )}
                                            {showPrint && showSettings && (<span style={{ color: "darkblue", fontSize: "16px", fontWeight: "normal" }}> {item.answer?.length || 0} </span>
                                            )}
                                            {showPrint && showSettings && (item.voiceName && item.voiceName?.length > 2) && (
                                                <span style={{ color: "black", fontSize: "16px" }}> voice : <strong>{item.voiceName}</strong></span>
                                            )}
                                            &nbsp; &nbsp;
                                            {showPrint && showSettings && (item.invocationType !== undefined && item.invocationType?.length > 2) && (
                                                <span style={{ color: "black", fontSize: "16px", fontWeight: "normal" }}> Type : <strong>{item.invocationType}</strong></span>
                                            )}
                                            &nbsp; &nbsp;
                                            {showPrint && showSettings && (!item.voiceName || (!item.voiceName || !item.voiceName?.length > 2)) && item.model !== modelGptImage && item.model !== modelGeminiImage && item.model !== 'azure-tts' && (
                                                <button
                                                    edge="end"
                                                    aria-label="print answer"
                                                    className="action_button"
                                                    onClick={() => {
                                                        const printWindow = window.open('', '', 'height=500,width=800');
                                                        const htmlContent = mdParser.render(item.answer);
                                                        printWindow.document.write('<html><head><title>Print</title>');
                                                        printWindow.document.write('<style>');
                                                        printWindow.document.write(`
                                                        body {
                                                            font-family: Arial, sans-serif;
                                                            margin: 20px;
                                                        }
                                                        table {
                                                            width: 100%;
                                                            border-collapse: collapse;
                                                            margin-bottom: 20px;
                                                        }
                                                        table, th, td {
                                                            border: 1px solid #ccc;
                                                        }
                                                        th, td {
                                                            padding: 8px;
                                                            text-align: left;
                                                        }
                                                        th {
                                                            background-color: #f2f2f2;
                                                        }
                                                        pre {
                                                            background-color: #f5f5f5;
                                                            padding: 10px;
                                                            overflow: auto;
                                                        }
                                                        code {
                                                            background-color: #f5f5f5;
                                                            padding: 2px 4px;
                                                        }
                                                    `);
                                                        printWindow.document.write('</style></head><body>');
                                                        printWindow.document.write(htmlContent);
                                                        printWindow.document.write('</body></html>');
                                                        printWindow.document.close();
                                                        printWindow.print();
                                                    }}
                                                >
                                                    Print <FaPrint />
                                                </button>
                                            )}

                                            &nbsp; &nbsp;
                                            {((!item.voiceName || !item.voiceName?.length > 2) && item.model !== modelGptImage && item.model !== modelGeminiImage && item.model !== 'azure-tts') && (!['practice_questions', 'quiz_with_choices', 'quiz', 'svg-dashboards', 'svg-charts', 'svg-geometry', 'draw-io'].includes(item.invocationType)) && showSettings && showDownloadTextButton && (<button className="action_button"
                                                onClick={() => {
                                                    const plainText = (item.answer || '')
                                                        .replace(/[#*~`>-]/g, '')
                                                        .replace(/\r?\n/g, '\r\n');
                                                    const blob = new Blob([plainText], { type: 'text/plain' });
                                                    const link = document.createElement('a');
                                                    link.href = URL.createObjectURL(blob);
                                                    if (plainText.length > 105) {
                                                        link.download = 'description.txt';
                                                    } else {
                                                        link.download = 'title.txt';
                                                    }
                                                    link.click();
                                                }}
                                            >
                                                Download Text
                                            </button>
                                            )}

                                            {item.answer && item.answer.includes('```') && (
                                                <button className="action_button"
                                                    onClick={async () => {
                                                        const startIndex = item.answer.indexOf('```');
                                                        const endIndex = item.answer.indexOf('```', startIndex + 3);
                                                        if (startIndex !== -1 && endIndex !== -1) {
                                                            const codeBlock = item.answer.substring(startIndex + 3, endIndex);
                                                            // Find the first newline to skip potential language identifier
                                                            const firstNewlineIndex = codeBlock.indexOf('\n');
                                                            const textToCopy = firstNewlineIndex !== -1
                                                                ? codeBlock.substring(firstNewlineIndex + 1).trim()
                                                                : codeBlock.trim(); // Handle case with no language identifier

                                                            if (textToCopy) {
                                                                try {
                                                                    await navigator.clipboard.writeText(textToCopy);
                                                                    alert('Code copied to clipboard!');
                                                                } catch (err) {
                                                                    console.error('Failed to copy text: ', err);
                                                                    alert('Failed to copy code.');
                                                                }
                                                            } else {
                                                                alert('No code found within the block to copy.');
                                                            }
                                                        } else {
                                                            alert('Could not find code block markers (```).');
                                                        }
                                                    }}
                                                >
                                                    Copy Code
                                                </button>
                                            )}
                                        </div>
                                        {(((['practice_questions', 'quiz_with_choices', 'quiz'].includes(item.invocationType))) && item.answer) && (<button
                                            className="action_button"
                                            onClick={() => {
                                                setCurrentDocId(item.id);
                                                setShowhomeWorkApp(true);
                                            }}
                                        >
                                            Go to Questions/Quiz Page
                                        </button>
                                        )}
                                        {(showPrint || item.invocationType === 'explain') && (
                                            <div style={{ fontSize: '16px' }}>
                                                {isiPhone &&
                                                    (item.model === modelGptImage || item.model === modelGeminiImage || item.model === 'azure-tts') && (
                                                        <button
                                                            className="action_button"
                                                            onClick={() => handleDownload(item.answer, item.model)}
                                                        >
                                                            {isDownloading ? (
                                                                <FaSpinner className="spinning" />
                                                            ) : (
                                                                <>Download <FaCloudDownloadAlt size={28} /></>
                                                            )}
                                                        </button>
                                                    )}


                                                <br />
                                                {item.showRawAnswer ? item.id : ''}
                                                {item.showRawAnswer ? item.id : ''}
                                                {item.voiceName?.length > 2 && (
                                                    <audio src={item.answer.match(/\((https?:\/\/[^\s)]+)\)/)[1]} controls style={{ marginBottom: '10px' }} />
                                                )}
                                                {item.answer && item.answer.includes('<svg') && (
                                                    <div
                                                        dangerouslySetInnerHTML={{
                                                            __html: item.answer.substring(
                                                                item.answer.lastIndexOf('<svg'),
                                                                item.answer.lastIndexOf('</svg>') + 6
                                                            ).replaceAll(' & ', ' &amp; ')
                                                        }}
                                                    />
                                                )}

                                                {item.invocationType === '3D_Model' && (
                                                    <div style={{ margin: '10px 0' }}>
                                                        <a
                                                            href="https://ochafik.com/openscad2/#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"
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            style={{ color: '#007bff', textDecoration: 'underline', fontWeight: 'bold' }}
                                                        >
                                                            View 3D Model - copy and paste the below code in the text box
                                                        </a>
                                                    </div>
                                                )}
                                                {item.answer.includes('<mxfile') && (
                                                    <>
                                                        <div style={{ margin: '10px 0' }}>
                                                            <a
                                                                href="https://draw.io"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                style={{ color: '#007bff', textDecoration: 'underline', fontWeight: 'bold' }}
                                                            >
                                                                Export below code as xml and open in draw.io (click here)
                                                            </a>
                                                        </div>
                                                        {item.answer && (
                                                            <div style={{
                                                                top: 0,
                                                                left: 0,
                                                                width: '90vw',
                                                                height: '80vh',
                                                                zIndex: 9999,
                                                                background: 'white',
                                                                overflow: 'auto',
                                                                padding: '40px 0 0 0'
                                                            }}>
                                                                <DrawIoEmbed xml={item.answer.substring(item.answer.lastIndexOf('<mxfile'), item.answer.lastIndexOf('</mxfile>') + 9).replaceAll(' & ', ' &amp; ')} />
                                                            </div>
                                                        )}
                                                    </>
                                                )}
                                                {(item.invocationType !== 'draw-io') && (item.svg_url?.length < 10 || !item.svg_url) && (
                                                    item.showRawAnswer ? ((!['practice_questions', 'quiz_with_choices', 'quiz'].includes(item.invocationType)) && item.answer) : (
                                                        item.answer && (!['practice_questions', 'quiz_with_choices', 'quiz'].includes(item.invocationType)) && (
                                                            <MdEditor
                                                                className="markdown-editor"
                                                                value={item.answer || ''} // Add default empty string
                                                                renderHTML={text => mdParser.render(text || '')} // Add default empty string
                                                                readOnly={true}
                                                                config={{
                                                                    view: {
                                                                        menu: false,
                                                                        md: false,
                                                                        html: true
                                                                    },
                                                                    canView: {
                                                                        menu: false,
                                                                        md: false,
                                                                        html: true,
                                                                        fullScreen: false,
                                                                        hideMenu: true
                                                                    }
                                                                }}
                                                            />
                                                        )
                                                    )
                                                )}

                                            </div>

                                        )}
                                        <br />
                                        <br />
                                        {/* Add reaction buttons JSX */}
                                        <div className="reaction-buttons">
                                            <button
                                                className={`reaction-btn ${item.reaction === 'love' ? 'active' : ''}`}
                                                onClick={() => saveReaction(item.id, 'love')}
                                            >
                                                👍👍 Helpful
                                            </button>
                                            <button
                                                className={`reaction-btn ${item.reaction === 'like' ? 'active' : ''}`}
                                                onClick={() => saveReaction(item.id, 'like')}
                                            >
                                                👍 Informative
                                            </button>
                                            <button
                                                className={`reaction-btn ${item.reaction === 'improve' ? 'active' : ''}`}
                                                onClick={() => saveReaction(item.id, 'improve')}
                                            >
                                                🤔 Could be better
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            ))}
                            {genaiData.some(item => item.question && item.answer) && (
                                <button
                                    className="fetchButton"
                                    onClick={fetchMoreData}
                                    style={{ marginTop: '20px', padding: '10px 20px', fontSize: '16px' }}
                                >
                                    Show more information
                                </button>
                            )}
                        </div>}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default GenAIApp;